/* eslint-disable */
// mixins/globalMixin.js
import { SignJWT, jwtVerify } from 'jose';
import store from "../store/index";




export default {
	data() {
		return {
			mixin_scriptLoaded: false,
			englishToHebrew: {
				'a': 'ש', 'b': 'נ', 'c': 'ב', 'd': 'ג', 'e': 'ק', 'f': 'כ', 'g': 'ע', 'h': 'י', 'i': 'ן', 'j': 'ח', 'k': 'ל', 'l': 'ך', 'm': 'צ', 'n': 'מ', 'o': 'ם', 'p': 'פ', 'q': '/', 'r': 'ר', 's': 'ד', 't': 'א', 'u': 'ו', 'v': 'ה', 'w': '\'', 'x': 'ס', 'y': 'ט', 'z': 'ז', 
				'A': 'ש', 'B': 'נ', 'C': 'ב', 'D': 'ג', 'E': 'ק', 'F': 'כ', 'G': 'ע', 'H': 'י', 'I': 'ן', 'J': 'ח', 'K': 'ל', 'L': 'ך', 'M': 'צ', 'N': 'מ', 'O': 'ם', 'P': 'פ', 'Q': '/', 'R': 'ר', 'S': 'ד', 'T': 'א', 'U': 'ו', 'V': 'ה', 'W': '\'', 'X': 'ס', 'Y': 'ט', 'Z': 'ז'
			  }
		};
	},

	methods: {
		decompressBase64Gzip(base64Data) {
			try {
				var compressedData = atob(base64Data);
             
				var binaryString = new Uint8Array(compressedData.length);
				for (var i = 0; i < compressedData.length; i++) {
					binaryString[i] = compressedData.charCodeAt(i);
				}
				
				var decompressedData = pako.inflate(binaryString, { to: 'string' });
			   
				var parsedData = JSON.parse(decompressedData);
			   
				return parsedData;
			}
			catch (error) {
				console.error('Error decompressing base64 gzip data:', error);
				return null;
			}
        },
		compressBase64Gzip(normalText){
			try {
				var binaryString = pako.gzip(normalText, { to: 'string' });
				var base64Data = btoa(String.fromCharCode.apply(null, binaryString));
				return base64Data;
			}
			catch (error) {
				console.error('Error compressing base64 gzip data:', error);
				return null;
			}

		},
		mixin_getRoundedTime() {
			const now = new Date();
		
			// Convert to UTC and add 1 minute
			const utcHours = now.getUTCHours();
			const utcMinutes = now.getUTCMinutes() + 2; // 2 minute buffer
		
			// Handle cases where minutes may exceed 59
			const adjustedHours = (utcMinutes >= 60) ? (utcHours + 1) % 24 : utcHours;
			const adjustedMinutes = utcMinutes % 60;
		
			// Format hours and minutes to ensure 2 digits
			const formattedHours = adjustedHours.toString().padStart(2, '0');
			const formattedMinutes = adjustedMinutes.toString().padStart(2, '0');
		
			return `${formattedHours}${formattedMinutes}`;
		},
		  async mixin_generateTokenForPayload(payload) {
			const FIXED_SECRET = process.env.VUE_APP_TOKEN; // Store this securely
			const domain = window.location.hostname;
			const date = Math.floor(Date.now() / 1000);
			const expirationTime = date + 120;
			
			const secret = new TextEncoder().encode(FIXED_SECRET);

            payload['exp'] = expirationTime;
            payload['domain'] = domain;
          
			const jwt = await new SignJWT(payload)
				.setProtectedHeader({ alg: 'HS256' })
				.sign(secret);
			
			// reverse the jwt
			return {"__": jwt.split('').reverse().join('')};
		},
		async mixin_generatePayloadFromToken(token) {
			const FIXED_SECRET = process.env.VUE_APP_TOKEN; // Store this securely
			const secret = new TextEncoder().encode(FIXED_SECRET);
			const jwt = token['__'].split('').reverse().join('');
			const payload = await jwtVerify(jwt, secret);
			return payload.payload;
		},
		// Encrypts the alphanumeric userId
		mixin_encryptUserId(userId) {
			try {
				// Get rounded time as a salt
				const timeComponent = this.mixin_getRoundedTime();

				// Combine components (time and userId)
				const combined = `${timeComponent}${userId}`;
				
				// Simple character transformation for both letters and numbers
				const transformed = combined.split('')
					.map(char => {
						if (/[a-zA-Z]/.test(char)) {
							// Shift alphabetic characters by 3 positions
							const base = char <= 'Z' ? 65 : 97;
							return String.fromCharCode(((char.charCodeAt(0) - base + 3) % 26) + base);
						} else if (/[0-9]/.test(char)) {
							// Shift numeric characters by 5 positions
							return ((parseInt(char) + 5) % 10).toString();
						}
						return char; // Leave dashes or other characters as is
					})
					.join('');
				
				return transformed;
			} catch (error) {
				console.error('Error encrypting userId:', error);
				return null;
			}
		},

		// Decrypts the alphanumeric userId
		mixin_decryptUserId(encryptedId) {
			try {
				if (!encryptedId) {
					return null;
				}

				// Reverse the character transformation
				const untransformed = encryptedId.split('')
					.map(char => {
						if (/[a-zA-Z]/.test(char)) {
							// Reverse the alphabetic character shift by 3
							const base = char <= 'Z' ? 65 : 97;
							return String.fromCharCode(((char.charCodeAt(0) - base - 3 + 26) % 26) + base);
						} else if (/[0-9]/.test(char)) {
							// Reverse the numeric shift by 5
							return ((parseInt(char) - 5 + 10) % 10).toString();
						}
						return char; // Leave dashes or other characters as is
					})
					.join('');

				// Extract the original userId after the time component
				return untransformed.slice(this.mixin_getRoundedTime().length);
			} catch (error) {
				console.error('Error decrypting userId:', error);
				return null;
			}
		},

		async mixin_generateToken(){
			//get VUE_APP_TOKEN
			const domain = window.location.hostname;
			const date = Math.floor(Date.now() / 1000)
			const expirationTime = date + 120; // 2 minute from now
	  
			// The secret key (token) from environment variables
			const token = process.env.VUE_APP_TOKEN;
			if (!token) {
			  console.error('Token not found in environment variables');
			  return;
			}
	  
			// Convert the secret key to a Uint8Array
			const secret = new TextEncoder().encode(token);
	  
			// Create and sign the JWT
			const jwt = await new SignJWT({ domain, exp: expirationTime })
			  .setProtectedHeader({ alg: 'HS256' })
			  .sign(secret);
	  
			// Set the token
			return jwt;
		},
		mixin_goTo(appVue, view) {
			if (appVue.$route.query.view != view) {
				const origin = window.location.origin;
				if (view != "home") {
					const target = "view=" + view;
					// redirect to origin + target
					window.location.href = origin + "/?" + target;
				} else {
					window.location.href = origin;
				}
				setTimeout(() => {
					window.scrollTo(0, 0);
				}, 1);
			}
		},


		  // Add cookie utility methods
		  mixin_setCookie(name, value, days = 1) {
			const expirationDate = new Date();
			expirationDate.setDate(expirationDate.getDate() + days);
			const cookieValue = JSON.stringify(value);
			document.cookie = `${name}=${encodeURIComponent(cookieValue)};expires=${expirationDate.toUTCString()};path=/`;
		  },
	  
		  mixin_getCookie(name) {
			const cookies = document.cookie.split(';');
			const cookie = cookies.find(c => c.trim().startsWith(name + '='));
			if (!cookie) return null;
			
			try {
			  return JSON.parse(decodeURIComponent(cookie.split('=')[1]));
			} catch {
			  return null;
			}
		  },
	  
		  mixin_removeCookie(name) {
			document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
		  },
	  
		  // Updated login method using the cookie mixins
		  async mixin_handleLogin() {
			try {
			  this.errorText = "";
			  const { email, password } = this;
			  
			  if (!email || !password) {
				return;
			  }
			  // Update store state
			  this.$store.state.useremail = email;
			  this.$store.state.password = password;
			  const login_res = await this.mixin_login(this, email, password);
			  // try decrypt requestData with mixin_generatePayloadFromToken
			  if (login_res.statusCode !== 200) {
				if (login_res.statusCode === 401) {
				  this.$store.state.username = login_res.data.userName;
				  this.errorText = login_res.data.message;
				  
				  // Store password in cookie
				  var obj = {
					"pwd": password,
				  }
				  // compress and set cookie
				  const compressedPwd = this.compressBase64Gzip(JSON.stringify(obj));
				  this.mixin_setCookie("up", compressedPwd);
	  
				  if (login_res.data.message === "סיסמה שגויה") {
					this.errorText = "סיסמא שגויה";
					this.refreshRecaptcha();
					return;
				  }
	  
				  //this.$store.state.currentUser = login_res.data;
				  	// Handle successful login
					var userData = {
						userid: login_res.data.userID,
						useremail: this.$store.state.useremail,
						username: login_res.data.userName,
						addressList: [],
					};
					// if message = "יש לאמת את החשבון"
					if (login_res.data.message === "יש לאמת את החשבון") {
						userData.Verified = false;
					}
					this.$store.state.currentUser = userData;
	  
					// Update store state
					this.$store.state.username = login_res.data.userName;
					this.$store.state.useremail = this.$store.state.useremail;
					//this.$store.state.password = password;

				  //set cookie
				  // compress
				  const compressedUserData = this.compressBase64Gzip(JSON.stringify(userData));
				  this.mixin_setCookie('user', compressedUserData);
				  this.mixin_goTo(this, 'approve');
				  return;
				}
	  
				this.errorText = login_res.data.message;
				return;
			  }
	  
			  // Handle successful login
			  var userData = {
				userid: login_res.data.userID,
				useremail: this.$store.state.useremail,
				username: login_res.data.userName,
				addressList: [],
				Verified: true
			  };
	  
			  // Update store state
			  this.$store.state.userid = login_res.data.userID;
			  this.$store.state.username = login_res.data.userName;
			  this.$store.state.currentUser = userData;
	  
			  // Clear existing cookies and set new user data
			  this.mixin_removeCookie('user');
			  // compress
			  const compressedUserData = this.compressBase64Gzip(JSON.stringify(userData));
			  this.mixin_setCookie('user', compressedUserData);
	  
			  // Check if user data was stored successfully
			  var deompressed = this.decompressBase64Gzip(this.mixin_getCookie('user'));
			  const storedUser = deompressed;
			  if (storedUser?.userid) {
				this.$store.state.currentUser = storedUser;
				this.mixin_goTo(this, "home");
			  }
			} catch (error) {
			  console.error('Login error:', error);
			  this.errorText = 'An error occurred during login';
			}
		},


		mixin_checkCookies() {
			
			// Using your mixin method
			// get up cookie and decompress
			const compressedPwd = this.mixin_getCookie('up');
			const up = this.decompressBase64Gzip(compressedPwd);
			 
			const userData = up.user;
			const pwd =  up.pwd;
			
			// Check if specific data exists
			// if (userData) {
			// 	console.log('User ID:', userData.userid);
			// 	console.log('User Email:', userData.useremail);
			// 	console.log('User Name:', userData.username);
			// }
		},


		mixin_getNumFetchByPage(pageNumber, limitFetch = 100, limitRows = 10) {
			pageNumber = Math.abs(parseInt(pageNumber, 10));
			limitFetch = Math.abs(parseInt(limitFetch, 10));
			limitRows = Math.abs(parseInt(limitRows, 10));

			const numFetch = (pageNumber * limitRows) / limitFetch;
			return Math.ceil(numFetch);
		},
		mixin_splitDataByFetch(data, numFetch, limitRows = 10) {
			numFetch = Math.abs(parseInt(numFetch, 10));
			limitRows = Math.abs(parseInt(limitRows, 10));

			const totalItems = data.length;
			const totalPages =
				Math.floor(totalItems / limitRows) + (totalItems % limitRows ? 1 : 0);
			const pageStart = (numFetch - 1) * totalPages;

			let result = [];
			for (let i = 0; i < totalItems; i += limitRows) {
				const chunk = data.slice(i, i + limitRows);
				const pageNumber = Math.floor(i / limitRows) + 1 + pageStart;
				result.push({ pageNumber: pageNumber, items: chunk });
			}

			return result;
		},
		mixin_computeTargetPath() {
			var obj_vuex = store.state.storeObject;
			if (obj_vuex == null) {
				// get parm  from vue router
				//if (this.$route.params.setlCode != null) {
				if (
					this.$route.query.view.startsWith("settlement") &&
					this.$route.query.id != null
				) {
					obj_vuex = {
						//baseId: this.$route.params.setlCode,
						baseId: this.$route.query.id,
						baseSearch: "settlement",
						levelType: null,
						levelId: null,
					};
				}
				//if (this.$route.params.neighborhoodId != null) {
				if (
					this.$route.query.view.startsWith("neighborhood") &&
					this.$route.query.id != null
				) {
					obj_vuex = {
						//baseId: this.$route.params.neighborhoodId,
						baseId: this.$route.query.id,
						baseSearch: "neighborhood",
						levelType: null,
						levelId: null,
					};
				}
				if (this.$route.params.addressId != null) {
					obj_vuex = {
						baseId: this.$route.params.addressId,
						baseSearch: "address",
						levelType: null,
						levelId: null,
					};
				}

				if (obj_vuex != null) {
					store.state.storeObject = obj_vuex;
				}
				else{
					return {
						rent: "",
						buy: "",
						info: "",
					}
				}
			}

			var baseId = null;
			var baseSearch = null;
			var levelType = null;
			var levelId = null;
			if (obj_vuex != null) {
				baseId = obj_vuex.baseId;
				baseSearch = obj_vuex.baseSearch;
				levelType = obj_vuex.levelType;
				levelId = obj_vuex.levelId;
			}

			if (baseId == null) {
				baseId = levelId;
				baseSearch = levelType;
			}

			let rent,
				buy,
				info = "/";

			if (baseSearch === "settlement") {
				// rent = `/settlement/${baseId}/rent/pricing`;
				// buy = `/settlement/${baseId}/buy/deals`;
				// info = `/settlement/${baseId}/buy/info`;

				buy = `/?view=settlement&id=${baseId}&page=deals`;
				info = `/?view=settlement_info&id=${baseId}&page=info`;
				rent = `/?view=settlement_rent&id=${baseId}&page=rent`;
			}

			if (baseSearch === "neighborhood") {
				// rent = `/neighborhood/${baseId}/rent/pricing`;
				//buy = `/neighborhood/${baseId}/buy/deals`;
				// info = `/neighborhood/${baseId}/buy/info`;

				buy = `/?view=neighborhood&id=${baseId}&page=deals`;
				info = `/?view=neighborhood_info&id=${baseId}&page=info`;
				rent = `/?view=neighborhood_rent&id=${baseId}&page=rent`;
			}

			if (baseSearch === "address") {
				if (levelType === "neighborhood") {
					// rent = `/neighborhood/${levelId}/rent/pricing`;
					// buy = `/address/${baseId}/buy/deals`;
					// info = `/neighborhood/${levelId}/buy/info`;
					rent = `/?view=neighborhood_rent&id=${levelId}&page=rent`;
					buy = `/?view=address&id=${baseId}&page=deals`;
					info = `/?view=neighborhood_info&id=${levelId}&page=info`;
				} else if (levelType === "settlement") {
					// rent = `/settlement/${levelId}/rent/pricing`;
					// buy = `/address/${baseId}/buy/deals`;
					// info = `/settlement/${levelId}/buy/info`;
					rent = `/?view=settlement_rent&id=${levelId}&page=rent`;
					buy = `/?view=address&id=${baseId}&page=deals`;
					info = `/?view=settlement_info&id=${levelId}&page=info`;
				}
			}

			if (baseSearch === "kparcel") {
				if (levelType === "neighborhood") {
					// rent = `/neighborhood/${levelId}/rent/pricing`;
					// buy = `/kparcel_all/${baseId}/buy/deals`;
					// info = `/neighborhood/${levelId}/buy/info`;
					rent = `/?view=neighborhood_rent&id=${levelId}&page=rent`;
					buy = `/?view=kparcel_all&id=${baseId}&page=deals`;
					info = `/?view=neighborhood_info&id=${levelId}&page=info`;
				} else if (levelType === "settlement") {
					// rent = `/settlement/${levelId}/rent/pricing`;
					// buy = `/kparcel_all/${baseId}/buy/deals`;
					// info = `/settlement/${levelId}/buy/info`;
					rent = `/?view=settlement_rent&id=${levelId}&page=rent`;
					buy = `/?view=kparcel_all&id=${baseId}&page=deals`;
					info = `/?view=settlement_info&id=${levelId}&page=info`;
				}
			}

			if (baseSearch === "street") {
				if (levelType === "neighborhood") {
					// rent = `/neighborhood/${levelId}/rent/pricing`;
					// buy = `/street/${baseId}/buy/deals`;
					// info = `/neighborhood/${levelId}/buy/info`;
					rent = `/?view=neighborhood_rent&id=${levelId}&page=rent`;
					buy = `/?view=street&id=${baseId}&page=deals`;
					info = `/?view=neighborhood_info&id=${levelId}&page=info`;
				} else if (levelType === "settlement") {
					// rent = `/settlement/${levelId}/rent/pricing`;
					// buy = `/street/${baseId}/buy/deals`;
					// info = `/settlement/${levelId}/buy/info`;
					rent = `/?view=settlement_rent&id=${levelId}&page=rent`;
					buy = `/?view=street&id=${baseId}&page=deals`;
					info = `/?view=settlement_info&id=${levelId}&page=info`;
				}
			}
			// if buy / rent / info is not defined, return ''
			rent = rent ? rent : '';
			buy = buy ? buy : '';
			info = info ? info : '';
			return { rent, buy, info };
		},
		mixin_getMapToken(appVue) {
			const config = appVue.$store.state.config;
			// Now, you can use the config data as needed
			if (config) {
				////
				// get url domain
				const baseUrl = window.location.protocol + "//" + window.location.host;
				if (baseUrl.includes("localhost")) {
					return config.map_token_local;
				} else if (baseUrl.includes("dev.nadlan.gov.il")) {
					return config.map_token_dev;
				} else if (baseUrl.includes("nadlan.gov.il")) {
					return config.map_token_prod;
				} else if (baseUrl.includes("d2gaw52pfu7mfz.cloudfront.net")) {
					return config.map_token_dev2;
				} else {
					return config.map_token;
				}
			} else {
				// run load config from state
				appVue.$store.dispatch("loadConfig");
				return null;
			}
		},

		mixin_loadScript() {
			if (this.mixin_scriptLoaded == false) {
				try {
					if (document.getElementById("govmap_script") != null) {
						this.mixin_scriptLoaded = true;
						return;
					}
					const script = document.createElement("script");
					//script.src = "https://old.govmap.gov.il/govmap/api/govmap.api.js";
					// get from config
					this.$store.dispatch("loadConfig");
					const config = this.$store.state.config;
					
					script.src = config.govmap_api_js;
					script.onload = this.scriptLoadedHandler;
					document.head.appendChild(script);
				} catch (error) {}
			}
		},
		async mixin_wait_scriptLoadedIsTrue() {
			this.mixin_loadScript();
			if (this.mixin_scriptLoaded == false) {
				// set interval until script loaded
				let intervalId = setInterval(function () {
					if (this.mixin_scriptLoaded == true) {
						clearInterval(intervalId);
					}
				}, 250);
				return;
			}
		},

		scriptLoadedHandler() {
			this.mixin_scriptLoaded = true;
			// Additional logic you want to execute after the script is loaded
		},


		mixin_allowMapSelection(appVue) {
			appVue.$store.state.mapSelectionAllowed = true;
		},

		mixin_disallowMapSelection(appVue) {
			appVue.$store.state.mapSelectionAllowed = false;
		},

		async mixin_setMap(appVue) {
			// wait for script to load
			await this.mixin_wait_scriptLoadedIsTrue();
			// get map token
			const mapToken = this.mixin_getMapToken(appVue);
			// get map config from store
			const config = appVue.$store.state.config;
			// load govmap script

			if (this.mixin_scriptLoaded == false) {
				this.mixin_loadScript();
			}


			//const url = appVue.$route.path;
			// get url from current browser address...
			let url = window.location.href;
			if (appVue.$store.state.searchType == null) {
				return;
			}
			//turn off ALL layers
			govmap.setVisibleLayers(
				[],
				[
					"KSHTANN_ASSETS",
					"KSHTANN_SETL_AREA",
					"KSHTANN_STREETS",
					"KSHTANN_NEIGHBORHOODS",
					"KSHTANN_ASSETS_STATIC",
				],
			);

			if (url.includes("settlement") && url.includes("deals")) {
				//turn on assets_polygons and setl_area
				govmap.setVisibleLayers(["KSHTANN_SETL_AREA"], []);
				//if (appVue.$store.state.mapSelectionAllowed == false) {
					// filter and zoom
					var params = {
						layerName: "KSHTANN_SETL_AREA",
						whereClause: "SETL_CODE = " + appVue.$store.state.setlCode, //appVue.$route.params.setlCode,
						zoomToExtent: true,
					};
					govmap.filterLayers(params);
				//}
				govmap.setVisibleLayers(
					["KSHTANN_ASSETS_STATIC", "KSHTANN_SETL_AREA"],
					[],
				);
			}

			if (url.includes("settlement") && url.includes("rent")) {
				//turn on setl_area
				govmap.setVisibleLayers(["KSHTANN_SETL_AREA"], []);
				// search and zoom
				var params = {
					layerName: "KSHTANN_SETL_AREA",
					fieldName: "SETL_CODE",
					fieldValues: [appVue.$route.query.id], //[appVue.$route.params.setlCode],
					highlight: true,
					fillColor: [176, 228, 248, 0.5],
				};
				govmap.searchInLayer(params);
			}

			if (
				url.includes("settlement") &&
				url.includes("info") &&
				appVue.$route.query.id != null
			) {
				//turn on setl_area
				govmap.setVisibleLayers(["KSHTANN_SETL_AREA"], []);
				// filter and zoom
				var params = {
					layerName: "KSHTANN_SETL_AREA",
					whereClause: "SETL_CODE = " + appVue.$route.query.id, //appVue.$route.params.setlCode,
					zoomToExtent: true,
				};
				govmap.filterLayers(params);
			}

			if (
				url.includes("neighborhood") &&
				url.includes("deals") &&
				appVue.$route.query.id != null
			) {
				//turn on assets_polygons and neighborhoods
				govmap.setVisibleLayers(
					["KSHTANN_ASSETS_STATIC", "KSHTANN_NEIGHBORHOODS"],
					[],
				);
				// filter and zoom
				if (appVue.$store.state.mapSelectionAllowed == false) {
					var params = {
						layerName: "KSHTANN_NEIGHBORHOODS",
						whereClause: "UNIQ_ID = " + appVue.$route.query.id, // + appVue.$route.params.neighborhoodId,
						zoomToExtent: true,
					};
					govmap.filterLayers(params);
				}
			}

			if (
				url.includes("neighborhood") &&
				url.includes("rent") &&
				appVue.$route.query.id != null
			) {
				govmap.setVisibleLayers(["KSHTANN_NEIGHBORHOODS"], []);
				// search and zoom
				var params = {
					layerName: "KSHTANN_NEIGHBORHOODS",
					fieldName: "UNIQ_ID",
					fieldValues: [appVue.$route.query.id],
					highlight: true,
					fillColor: [176, 228, 248, 0.5],
				};
				govmap.searchInLayer(params);
			}

			if (
				url.includes("neighborhood") &&
				url.includes("info") &&
				appVue.$route.query.id != null
			) {
				//turn on neighborhoods
				govmap.setVisibleLayers(["KSHTANN_NEIGHBORHOODS"], []);
				// filter and zoom
				var params = {
					layerName: "KSHTANN_NEIGHBORHOODS",
					whereClause: "UNIQ_ID = " + appVue.$route.query.id,
					zoomToExtent: true,
				};
				govmap.filterLayers(params);
			}

			if (
				url.includes("address") &&
				url.includes("deals") &&
				appVue.$store.state.polygonId != null
			) {
				//turn on assets_polygons and setl_area
				govmap.setVisibleLayers(
					["KSHTANN_ASSETS_STATIC", "KSHTANN_SETL_AREA"],
					[],
				);
				if (appVue.$store.state.mapSelectionAllowed == false) {
					// search and zoom
					var params = {
						layerName: "KSHTANN_ASSETS",
						fieldName: "POLYGON_ID",
						fieldValues: [appVue.$store.state.polygonId],
						highlight: true,
						outLineColor: [0, 0, 255, 1],
						fillColor: [0, 0, 255, 0.3],
					};
					govmap.searchInLayer(params);
				}

				//set MOUSE_MOVE govmap event
				//govmap.onEvent(govmap.events.MOUSE_MOVE).progress(function (e) {
					// 	"mapPoint": {
					// 		"type": "point",
					// 		"x": 601697.1602530006,
					// 		"y": 674402.7736642276,
					// 		"spatialReference": {
					// 			"wkid": 2039
					// 		}
					// 	},
					// 	"screenPoint": {
					// 		"type": "point",
					// 		"x": 698,
					// 		"y": 296
					// }  }
				//});
			}

			if (
				url.includes("address") &&
				url.includes("rent") &&
				appVue.$store.state.polygonId != null
			) {
				//turn on assets_polygons
				govmap.setVisibleLayers(["KSHTANN_ASSETS_STATIC"], []);
				if (appVue.$store.state.mapSelectionAllowed == false) {
					// search and zoom
					var params = {
						layerName: "KSHTANN_ASSETS_STATIC",
						fieldName: "POLYGON_ID",
						fieldValues: [appVue.$store.state.polygonId],
						highlight: true,
						fillColor: [0, 0, 255, 0.3],
					};
					govmap.searchInLayer(params);
				}
			}

			if (
				url.includes("address") &&
				url.includes("info") &&
				appVue.$store.state.polygonId != null
			) {
				//turn on assets_polygons
				govmap.setVisibleLayers(["KSHTANN_ASSETS_STATIC"], []);
				// search and zoom
				var params = {
					layerName: "KSHTANN_ASSETS_STATIC",
					fieldName: "POLYGON_ID",
					fieldValues: [appVue.$store.state.polygonId],
					highlight: true,
					outLineColor: [0, 0, 255, 1],
					fillColor: [0, 0, 255, 0.3],
				};
				govmap.searchInLayer(params);
			}

			if (
				url.includes("kparcel_all") &&
				url.includes("deals") //&&
				//appVue.$store.state.polygonId != null
				//&& appVue.$store.state.mapSelectionAllowed == false
			) {
				if (appVue.$store.state.polygonId == null) {
					appVue.$store.state.polygonId = appVue.$route.query.id
				}
				//turn on assets_polygons and setl_area
				govmap.setVisibleLayers(
					["KSHTANN_ASSETS_STATIC", "KSHTANN_SETL_AREA"],
					[],
				);
				// search and zoom
				govmap.searchInLayer({
					layerName: "KSHTANN_ASSETS",
					fieldName: "POLYGON_ID",
					fieldValues: [appVue.$store.state.polygonId],
					highlight: true,
					outLineColor: [0, 0, 255, 1],
					fillColor: [0, 0, 255, 0.3],
				});
			}

			if (
				url.includes("kparcel_all") &&
				url.includes("rent") &&
				appVue.$store.state.polygonId != null
			) {
				//turn on assets_polygons
				govmap.setVisibleLayers(["KSHTANN_ASSETS_STATIC"], []);
				// search and zoom
				var params = {
					layerName: "KSHTANN_ASSETS_STATIC",
					fieldName: "POLYGON_ID",
					fieldValues: [appVue.$store.state.polygonId],
					highlight: true,
					outLineColor: [0, 0, 255, 1],
					fillColor: [0, 0, 255, 0.3],
				};
				govmap.searchInLayer(params);
			}

			// if (
			// 	url.includes("kparcel_all") &&
			// 	url.includes("deals") &&
			// 	appVue.$store.state.polygonId != null
			// ) {
			// 	//turn on assets_polygons
			// 	//govmap.setVisibleLayers(["KSHTANN_ASSETS_STATIC"], []);
			// 	// search and zoom

			// 	govmap.searchInLayer({
			// 		layerName: "KSHTANN_ASSETS",
			// 		fieldName: "POLYGON_ID",
			// 		fieldValues: [appVue.$store.state.polygonId],
			// 		highlight: true,
			// 		outLineColor: [0, 0, 255, 1],
			// 		fillColor: [0, 0, 255, 0.3],
			// 	});
	
			// }

			//set click event
			if (appVue.$store.state.mapSelectionAllowed == true) {
				govmap.onEvent(govmap.events.CLICK).progress(function (e) {
					// if (url.includes("rent")) {
					// 	//get neighborhoods layers data from clicked feature..
					// 	var params = {
					// 		LayerName: "KSHTANN_NEIGHBORHOODS",
					// 		Point: {
					// 			x: e.mapPoint.x,
					// 			y: e.mapPoint.y,
					// 		},
					// 		Radius: 1,
					// 	};
					// 	govmap.getLayerData(params).then(function (response) {
					// 		if (response.data == null) {
					// 			appVue.$store.state.clickedNeighborhoodName = null;
					// 			appVue.$store.state.clickedRentPrice = null;
					// 			// stop highlight
					// 			govmap.clearSelection();
					// 			return;
					// 		}
					// 		const uniq_id = response.data[0].Fields[1].Value;
					// 		// get neighborhood data
					// 		const d_url =
					// 			appVue.$store.state.config.s3_page_base +
					// 			"/neighborhood/rent/" +
					// 			uniq_id +
					// 			".json" + 
					// 			"?t=" + new Date().getTime();
					// 			 ;
					// 		fetch(d_url).then(function (response) {
					// 			const data = response.json();
					// 			data.then(function (e) {
					// 				const init_x = e.x;
					// 				const init_y = e.y;
					// 				//set store neighborhood, setlName
					// 				appVue.$store.state.clickedNeighborhoodName =
					// 					e.neighborhoodName;
					// 				//get last
					// 				const gr_data = e.trends.rooms[3].graphData;
					// 				// take last price fro lastYearAvgPrice
					// 				console.log(e.trends.rooms, 'e.trends.rooms');
					// 				appVue.$store.state.clickedRentPrice = e.trends.rooms[3].summary.lastYearAvgPrice;
					// 				appVue.$store.state.clickedRentPrice_3 = e.trends.rooms[0].summary.lastYearAvgPrice;
					// 				appVue.$store.state.clickedRentPrice_4 = e.trends.rooms[1].summary.lastYearAvgPrice;
					// 				appVue.$store.state.clickedRentPrice_5 = e.trends.rooms[2].summary.lastYearAvgPrice;
					// 				if (appVue.$store.state.clickedRentPrice == null){
					// 					var  lastIndex = 0;
					// 					lastIndex = gr_data.findIndex(price =>  price.neighborhoodPrice > 0); 
					// 					if (!gr_data.some(num => num > 0)) {
					// 						lastIndex = 1;
					// 					}
					// 					appVue.$store.state.clickedRentPrice = gr_data[lastIndex].neighborhoodPrice;
					// 				}
	
									
		
	
					// 				// highlight and zoom
					// 				var params = {
					// 					layerName: "KSHTANN_NEIGHBORHOODS",
					// 					fieldName: "UNIQ_ID",
					// 					fieldValues: [e.neighborhoodId],
					// 					highlight: true,
					// 					fillColor: [176, 228, 248, 0.5],
					// 				};
					// 				govmap.searchInLayer(params);

					// 				//set MOUSE_MOVE govmap event - if rent page
					// 				if (url.includes("rent")) {

					// 						govmap.onEvent(govmap.events.PAN).progress(function (e) {
					// 							//e.extent:
					// 							// {
					// 							// 	"xmin": 198427.3483415164,
					// 							// 	"ymin": 743482.506927686,
					// 							// 	"xmax": 201615.58388465416,
					// 							// 	"ymax": 744535.5507004403,
					// 							// 	"spatialReference": {
					// 							// 		"wkid": 2039
					// 							// 	}
					// 							// }
					// 							if (appVue.$store.state.clickedNeighborhoodName != null) {
					// 								// remove highlight 
					// 								// if init_x/init_y to far from extent middle x/y
					// 								const middle_x = (e.extent.xmin + e.extent.xmax) / 2;
					// 								const middle_y = (e.extent.ymin + e.extent.ymax) / 2;
					// 								const distance = Math.sqrt(
					// 									Math.pow(init_x - middle_x, 2) +
					// 									Math.pow(init_y - middle_y, 2)
					// 								);
					// 								if (distance > 1000) {
					// 									// remove highlight
					// 									govmap.clearSelection();
					// 									appVue.$store.state.clickedNeighborhoodName = null;
					// 									appVue.$store.state.clickedRentPrice = null;
					// 								}
					// 							}
					// 						});
										
					// 				}
					// 			});
					// 		});
					// 	});
					// } 
					
					// if ( url.includes("deals") && appVue.$store.state.searchType != null) {
					// 	var params = {
					// 		LayerName: "KSHTANN_ASSETS",
					// 		Point: {
					// 			x: e.mapPoint.x,
					// 			y: e.mapPoint.y,
					// 		},
					// 		Radius: 1,
					// 	};
					// 	var _appVue = appVue;
					// 	var addrId = null;
					// 	govmap.getLayerData(params).then(function (response) {
					// 		if (response.data == null) {
					// 			// stop highlight
					// 			govmap.clearSelection();
					// 			return;
					// 		}
					// 		var a = response.data[0].Fields;
					// 		// get from a where FieldName == "POLYGON_ID"
					// 		a.forEach((element) => {
					// 			if (element.FieldName == "POLYGON_ID") {
					// 				var polygon_id = element.Value;
					// 				// hightlight the current polygon (blue) (searchInLayer)
					// 				var params = {
					// 					layerName: "KSHTANN_ASSETS",
					// 					fieldName: "POLYGON_ID",
					// 					fieldValues: [polygon_id],
					// 					highlight: true,
					// 					outLineColor: [0, 0, 255, 1],
					// 					fillColor: [0, 0, 255, 0.3],
					// 				};
					// 				govmap.searchInLayer(params);
					// 				// get adddresId from config.addr_index
					// 				var addr_index_url = _appVue.$store.state.config.addr_index;
					// 				fetch(addr_index_url).then(function (response) {
					// 					const data = response.json();
					// 					data.then(function (e) {
					// 						// if polygon_id contain '-'
					// 						if (!polygon_id.includes("-")) {
					// 							// check if dictionary e contains any value[0] == polygon_id
					// 							for (let key in e) {
					// 								if (e.hasOwnProperty(key) && e[key][0] == polygon_id) {
					// 									addrId = key;
					// 								}
					// 							}
					// 							if (addrId != null) {
					// 								_appVue.updateUrl(addrId);
					// 							}
					// 						} else {
					// 							_appVue.updateUrlParcel(polygon_id);
					// 						}
					// 					});
					// 				});
					// 			}
					// 		});
					// 	});
					// }
	
					if (url.includes("info")) {
						var _appVue = appVue;
	
						var params = {
							LayerName: "CELL_ACTIVE",
							Point: {
								x: e.mapPoint.x,
								y: e.mapPoint.y,
							},
							Radius: 50,
						};
						var _appVue = appVue;
						var addrId = null;
						govmap.getLayerData(params).then(function (response) {
							if (response.data == null) {
								// stop highlight
								govmap.clearSelection();
								// hide infoBox
								_appVue.featureSelected = null;
								return;
							}
							var a = response.data[0].Fields;
							// get from a where FieldName == "POLYGON_ID"
							var obj = {};
							_appVue.featureSelected = {};
							a.forEach((element) => {
								obj[element.FieldName] = element.Value;
							});
							_appVue.featureSelected.layerName = "CELL_ACTIVE";
	
							_appVue.featureSelected.name = obj["חברה"] + " " + obj["מספר אתר"];
							_appVue.featureSelected.address = obj["כתובת האתר"];
							_appVue.featureSelected.type = obj["סוג אתר"];
							_appVue.featureSelected.lastCheck = obj["בדיקה תקופתית אחרונה"];
							_appVue.featureSelected.maxRadiation =
								obj["עוצמת קרינה מרבית ביח' מיקרו לסמ\"ר"];
							_appVue.featureSelected.percentage =
								obj["אחוז מסך החשיפה שקבע ארגון הבריאות העולמי"];
							_appVue.featureSelected.transmissionTechnology =
								obj["טכנולוגיית שידור"];
						});
	
						var params = {
							LayerName: "SVIVA_NITUR_MIFAL",
							Point: {
								x: e.mapPoint.x,
								y: e.mapPoint.y,
							},
							Radius: 50,
						};
	
						govmap.getLayerData(params).then(function (response) {
							
							if (response.data == null) {
								// stop highlight
								govmap.clearSelection();
								return;
							}
							var a = response.data[0].Fields;
							// get from a where FieldName == "POLYGON_ID"
	
							var obj = {};
							_appVue.featureSelected = {};
							a.forEach((element) => {
								obj[element.FieldName] = element.Value;
							});
							
							//sample data of obj:
							// {
							// 	"למידע על פליטות מזהמים בארובות": "https://www.gov.il/apps/sviva/airq/atar_digumi_arubut_details?mifalkey=54664",
							// 	"שם": "קניאל תעשיות א.ט.ג בע\"מ- כ\"ס 54664",
							// 	"מחוז": "מרכז",
							// 	"רשות מקומית": "כפר סבא",
							// 	"ישוב": "כפר סבא",
							// 	"X": "191462",
							// 	"Y": "676118"
							// }
							_appVue.featureSelected.layerName = "SVIVA_NITUR_MIFAL";
							_appVue.featureSelected.name = obj["שם"];
							_appVue.featureSelected.address = obj["ישוב"];
							_appVue.featureSelected.rashut = obj["רשות מקומית"];
							_appVue.featureSelected.link =
								obj["למידע על פליטות מזהמים בארובות"];
						});
					}
				});


				//govmap.onEvent(govmap.events.MOUSE_MOVE).progress(function (e) {
					// 	"mapPoint": {
					// 		"type": "point",
					// 		"x": 601697.1602530006,
					// 		"y": 674402.7736642276,
					// 		"spatialReference": {
					// 			"wkid": 2039
					// 		}
					// 	},
					// 	"screenPoint": {
					// 		"type": "point",
					// 		"x": 698,
					// 		"y": 296
					// }  }
				//});
			}
			else{
				//remove click event
				govmap.unbindEvent(govmap.events.CLICK);
				//remove mouse move event
				govmap.unbindEvent(govmap.events.PAN);

			}


			if (
				appVue.$store.state.searchType == "STREET" ||
				appVue.$store.state.searchType == "street"
			) {
				govmap.setVisibleLayers(
					[],
					[
						"KSHTANN_SETL_AREA",
						"KSHTANN_ASSETS",
						"KSHTANN_STREETS",
						"KSHTANN_NEIGHBORHOODS",
						"KSHTANN_ASSETS_STATIC",
					],
				);
				govmap.setVisibleLayers(
					["KSHTANN_SETL_AREA", "KSHTANN_ASSETS_STATIC", "KSHTANN_STREETS"],
					[],
				);
				if (url.includes("deals")) {
					// filter layer
					// filter and zoom
					var params = {
						layerName: "KSHTANN_STREETS",
						whereClause: "STR_ID = " + appVue.$store.state.streetCode,
						zoomToExtent: true,
					};
					govmap.filterLayers(params);
				}
			}

			//}
		},

		mixin_clearAllGraphicsLayers(appVue) {
			govmap.clearGeometriesByName(appVue.$store.state.featuresIds);
		},

		mixin_setVisibleLayers(layersOn, layersOff) {
			if (globalThis.hasOwnProperty('govmap')){
				govmap.setVisibleLayers(layersOn, layersOff);
			}
			
		},

		mixin_displayGraphicLayer(appVue, layerName, subType, clearExisting) {
			
			
			clearExisting = clearExisting == null ? true : clearExisting;

			if (clearExisting == true) {
				govmap.clearGeometriesByName(appVue.$store.state.featuresIds);
			}

			//const baseUrl = window.location.protocol + "//" + window.location.host;
			const baseUrl = 'https://dev.nadlan.gov.il';
			const markerUrl =
				baseUrl + "/images/mapIcons/" + appVue.layerIcon + ".png"; //kidgarden.png";
			if (appVue.nearByObjects == null) {
				return;
			}
			var subTypes = appVue.nearByObjects[layerName];
			var features = [];
			var symbols_list = [];
			
			if (appVue.$store.state.selectedNearByObject.hasOwnProperty("children")) {
				if (subType == null) {
					//alert('subType is null')
					for (let key in subTypes) {
						
						var current_icon = "";
						

						appVue.$store.state.selectedNearByObject.children.forEach(
							function (child) {
								if (child.mapLayerName == key) {
									current_icon = child.layerIcon;
								}
							},
						);

						var current_features = subTypes[key];
						
						current_features.forEach(function (feat) {
							feat.icon = current_icon;
							features.push(feat);
						});
					}
				} else {
					features = subTypes[subType];
				}
			} else {
				features = subTypes;
			}

			if (features == [] || features == null) {
				return;
			}

			var res_list = [];
			var wkts_list = [];
			var geomData_list = [];
			var names_list = [];
			
			features.forEach(function (feat) {
				wkts_list.push("POINT(" + feat.x + " " + feat.y + ")");
				geomData_list.push(feat);
				names_list.push(feat.id);
				appVue.$store.state.featuresIds.push(feat.id);
				if (feat.icon == null) {
					symbols_list.push({
						url: markerUrl,
						width: 50,
						height: 50,
					});
				} else {
					symbols_list.push({
						url: baseUrl + "/images/mapIcons/" + feat.icon + ".png",
						width: 50,
						height: 50,
					});
				}
			});
			var data = {
				wkts: wkts_list,
				geomData: geomData_list,
				names: names_list,
				geometryType: govmap.drawType.Point,
				defaultSymbol: {
					url: markerUrl,
					width: 50,
					height: 50,
				},

				symbols: symbols_list,
				clearExisting: clearExisting,
				showBubble: false,
				data: features,
			};
			
			govmap.displayGeometries(data).progress(function (response) {
				res_list.push(response);
				setTimeout(function () {
					if (res_list.length > 0) {
						
						appVue.featureSelected = res_list[0].data.geomData;
					}
					res_list = [];
				}, 100);
			});
		},

		mixin_createMap(appVue) {
			const map_token = this.mixin_getMapToken(appVue);
			const _this = this;

			this.mixin_loadScript();

			if (this.mixin_scriptLoaded == false) {
				// set interval until script loaded
				let intervalId = setInterval(function () {
					_this.mixin_loadScript();
					if (_this.mixin_scriptLoaded == true) {
						clearInterval(intervalId);
					}
				}, 250);
				return;
			}

			if (this.mixin_scriptLoaded == true) {
				// if element with id "map" exists, create map
				if (document.getElementById("map") == null) {
					return;
				}
				govmap.createMap("map", {
					visibleLayers: [],
					layers: [
						"KSHTANN_SETL_AREA",
						"KSHTANN_ASSETS",
						"KSHTANN_STREETS",
						"KSHTANN_NEIGHBORHOODS",
						"KSHTANN_ASSETS_STATIC",
					],
					layersMode: 4,
					token: map_token,
					showXY: false,
					identifyOnClick: false,
					isEmbeddedToggle: false,
					background: 0,
					zoomButtons: false


				});
				appVue.$store.state.mapCreated = true;

				//set map
				// setTimeout(async function () {
				// 	await _this.mixin_setMap(appVue);
				// 	//set map div
				// 	const div = document.getElementById("ifrMap");
				// 	if (div) {
				// 		div.style.borderRadius = "15px";
				// 	}
				// }, 500);
			} else {
				// set interval until script loaded
				let intervalId = setInterval(function () {
					this.mixin_loadScript();
					if (_this.mixin_scriptLoaded == true) {
						clearInterval(intervalId);
					}
				}, 250);
				return;
			}
		},

		PointToExtent(x, y, r) {
			let x1 = x - r;
			let y1 = y - r;
			let x2 = x + r;
			let y2 = y + r;
			return `POLYGON((${x1} ${y1}, ${x1} ${y2}, ${x2} ${y2}, ${x2} ${y1}, ${x1} ${y1}))`;
		},

		mixin_waitForNeighUpdate(appVue) {
			return new Promise((resolve) => {
				// Watch for changes in the state
				const unwatch = appVue.$watch(
					() => appVue.$store.state.neighborhoodId,
					(newValue, oldValue) => {
						// Check if the neighborhoodId has been updated
						if (newValue !== oldValue) {
							// If updated, resolve the promise
							resolve();
							// Stop watching for changes
							unwatch();
						}
					},
				);
			});
		},

		mixin_waitForSetlUpdate(appVue) {
			return new Promise((resolve) => {
				// Watch for changes in the state
				const unwatch = appVue.$watch(
					() => appVue.$store.state.setlCode,
					(newValue, oldValue) => {
						
						// Check if the neighborhoodId has been updated
						if (newValue != null) {
							

							// If updated, resolve the promise
							resolve();
							// Stop watching for changes
							unwatch();
						}
					},
				);
			});
		},

		mixin_waitForKParcelUpdate(appVue) {
			return new Promise((resolve) => {
				// Watch for changes in the state
				const unwatch = appVue.$watch(
					() => appVue.$store.state.kParcel,
					(newValue, oldValue) => {
						// Check if the neighborhoodId has been updated
						if (newValue !== oldValue) {
							// If updated, resolve the promise
							resolve();
							// Stop watching for changes
							unwatch();
						}
					},
				);
			});
		},

		mixin_waitForStreetUpdate(appVue) {
			return new Promise((resolve) => {
				// Watch for changes in the state
				const unwatch = appVue.$watch(
					() => appVue.$store.state.streetCode,
					(newValue, oldValue) => {
						// Check if the neighborhoodId has been updated
						if (newValue !== oldValue) {
							// If updated, resolve the promise
							resolve();
							// Stop watching for changes
							unwatch();
						}
					},
				);
			});
		},

		mixin_waitForAddressUpdate(appVue) {
			return new Promise((resolve) => {
				// Watch for changes in the state
				const unwatch = appVue.$watch(
					() => appVue.$store.state.polygonId,
					(newValue, oldValue) => {
						// Check if the neighborhoodId has been updated
						if (newValue !== oldValue) {
							// If updated, resolve the promise
							resolve();
							// Stop watching for changes
							unwatch();
						}
					},
				);
			});
		},

		mixin_waitForMapLoad(appVue) {
			return new Promise((resolve) => {
				// Watch for changes in the state
				const unwatch = appVue.$watch(
					() => appVue.$store.state.mapCreated,
					(newValue, oldValue) => {
						// Check if the neighborhoodId has been updated
						if (newValue == true || oldValue == true) {
							// If updated, resolve the promise

							resolve();
							// Stop watching for changes
							unwatch();
						}
					},
				);
			});
		},
		degreesToRadians(degrees) {
			return (degrees * Math.PI) / 180;
		},

		pow2(x) {
			return x * x;
		},

		pow3(x) {
			return x * x * x;
		},

		pow4(x) {
			return x * x * x * x;
		},
		WgsToIsrael(latitude, longitude) {
			longitude = this.degreesToRadians(longitude);

			latitude = this.degreesToRadians(latitude);

			//LatLongToITM(latitude, longitud);

			// Projection parameters

			var centralMeridian = this.degreesToRadians(35.2045169444444); // central meridian of ITM projection

			var k0 = 1.0000067; // scale factor

			// Ellipsoid constants (WGS 80 datum)

			var a = 6378137; // equatorial radius

			var b = 6356752.3141; // polar radius

			var e = Math.sqrt(1 - (b * b) / a / a); // eccentricity

			var e1sq = (e * e) / (1 - e * e);

			var n = (a - b) / (a + b);

			// Curvature at specified location

			var tmp = e * Math.sin(latitude);

			var nu = a / Math.sqrt(1 - tmp * tmp);

			// Meridional arc length

			var n3 = this.pow3(n);

			var n4 = this.pow4(n);

			var A0 =
				a * (1 - n + ((5 * n * n) / 4) * (1 - n) + ((81 * n4) / 64) * (1 - n));

			var B0 =
				((3 * a * n) / 2) *
				(1 - n - ((7 * n * n) / 8) * (1 - n) + (55 * n4) / 64);

			var C0 = ((15 * a * n * n) / 16) * (1 - n + ((3 * n * n) / 4) * (1 - n));

			var D0 = ((35 * a * n3) / 48) * (1 - n + (11 * n * n) / 16);

			var E0 = ((315 * a * n4) / 51) * (1 - n);

			var S =
				A0 * latitude -
				B0 * Math.sin(2 * latitude) +
				C0 * Math.sin(4 * latitude) -
				D0 * Math.sin(6 * latitude) +
				E0 * Math.sin(8 * latitude);

			// Coefficients for ITM coordinates

			var p = longitude - centralMeridian;

			var Ki = S * k0;

			var Kii = (nu * Math.sin(latitude) * Math.cos(latitude) * k0) / 2;

			var Kiii =
				((nu * Math.sin(latitude) * this.pow3(Math.cos(latitude))) / 24) *
				(5 -
					this.pow2(Math.tan(latitude)) +
					9 * e1sq * this.pow2(Math.cos(latitude)) +
					4 * e1sq * e1sq * this.pow4(Math.cos(latitude))) *
				k0;

			var Kiv = nu * Math.cos(latitude) * k0;

			var Kv =
				this.pow3(Math.cos(latitude)) *
				(nu / 6) *
				(1 -
					this.pow2(Math.tan(latitude)) +
					e1sq * this.pow2(Math.cos(latitude))) *
				k0;

			var easting = Math.round(219529.58 + Kiv * p + Kv * this.pow3(p) - 60);

			var northing = Math.round(
				Ki + Kii * p * p + Kiii * this.pow4(p) - 3512424.41 + 626907.39 - 45,
			);

			return [easting, northing];
		},
		updateUrl(addressId) {
			//if (this.$route.params.addressId != addressId) {
			if (this.$route.query.id != addressId) {
				const origin = window.location.origin;
				const target = "view=address&id=" + addressId + "&page=deals";
				// redirect to origin + target
				window.location.href = origin + "/?" + target;

				// this.$router.push({
				// 	name: "address",
				// 	params: { addressId: addressId },
				// });
				setTimeout(() => {
					//window.location.reload();
					//go to top
					window.scrollTo(0, 0);
				}, 10);
			}
		},
		updateUrlParcel(polygonId) {
			if (polygonId.includes("-")) {
				if (this.$route.params.kParcel != polygonId) {
					this.$router.push({
						name: "kparcel_all",
						params: { kParcel: polygonId },
					});
					setTimeout(() => {
						window.location.reload();
						//go to top
						window.scrollTo(0, 0);
					}, 10);

					var params = {
						layerName: "KSHTANN_ASSETS",
						fieldName: "ID",
						fieldValues: [polygonId],
						highlight: true,
					};
					govmap.searchInLayer(params);

					window.location.reload();
				}
			}
		},
		mixin_zoomCurrentLocation(appVue) {
			var _this = this;
			if (navigator.geolocation) {
				navigator.geolocation.getCurrentPosition((position) => {
					const coords = position.coords;
					
					var itm_coordes = _this.WgsToIsrael(
						coords.latitude,
						coords.longitude,
					);
					
					var x = itm_coordes[0];
					var y = itm_coordes[1];
					// get ASSETS layers data...
					var params = {
						LayerName: "KSHTANN_ASSETS",
						Point: {
							x: x,
							y: y,
						},
						Radius: 100,
					};

					govmap.getLayerData(params).then(function (response) {
						
						var distance = 1000;
						if (response.data == null) {
							// stop highlight
							govmap.clearSelection();
							appVue.$store.state.loading = false;
							var text = "לא נמצאו תוצאות במיקומך"
							appVue.$store.state.statusText = text;
							return;
						}
						var polygonId = null;
						var addrId = null;
						response.data.forEach(function (e) {
							if (e.distance < distance) {
								
								distance = e.distance;
								for (let key in e.Fields) {
									if (e.Fields[key].FieldName == "POLYGON_ID") {
										polygonId = e.Fields[key].Value;
									}
								}
							}
							else{
								var text = "לא נמצאו תוצאות במיקומך"
								appVue.$store.state.statusText = text;
							}
						});
						
						// get adddresId from config.addr_index
						var addr_index_url = appVue.$store.state.config.addr_index; //https://d30nq1hiio0r3z.cloudfront.net/api/index/PolyNeighSett.json
						var _appVue = appVue;
						fetch(addr_index_url).then(function (response) {
							const data = response.json();
							data.then(function (e) {
								// if polygon_id contain '-'
								if (!polygonId.includes("-")) {
									// check if dictionary e contains any value[0] == polygon_id
									for (let key in e) {
										if (e.hasOwnProperty(key) && e[key][0] == polygonId) {
											addrId = key;
										}
									}
									if (addrId != null) {
										//appVue.$store.state.loading = false;
										_this.updateUrl(addrId);
									}
								} else {
									//appVue.$store.state.loading = false;
									_this.updateUrlParcel(polygonId);
								}
							});
						});
					});
				});
			}
			else {
				appVue.$store.state.loading = false;
				var text = "יש לאפשר שימוש במיקום כדי להשתמש באפשרות זו";
				appVue.$store.state.statusText = text;
			}
		},
		async mixin_showResults(appVue) {
			var thisMixin = this;
			var storeObject = {};
			appVue.search = appVue.$store.state.search;

			// appVue.$store.state.searchType came from this dictionary (from on select in the autocomplete search box):
			// var searchTypes = {
			// 	NEIGHBORHOOD: 4,
			// 	STREET: 2,
			// 	ADDRESS: 1,
			// 	SETTLEMENT: 8,
			// 	KPARCEL_ALL: 16384,
			// };
			// for example: searchType of ADDRESS is 1

			var searchType = appVue.$store.state.searchType; // 4
			appVue.processing = true;
			appVue.$store.state.processing = true;
			appVue.statusText = "";
			appVue.addressId = null;
			appVue.streetId = null;
			appVue.neighborhoodId = null;
			appVue.setlCode = null;
			appVue.deals = [];
			// search_baseUrl = "https://es.govmap.gov.il/TldSearch";
			var url =
				appVue.$store.state.config.search_baseUrl +
				"/api/DetailsByQuery?query=" +
				appVue.search +
				"&lyrs=" +
				searchType +
				"&gid=nadlan";
			if (
				appVue.$store.state.config.search_baseUrl ==
				"https://www.nadlan.gov.il/TldSearch"
			) {
				url =
					appVue.$store.state.config.search_baseUrl +
					"/api/DetailsByQuery?query=" +
					appVue.search +
					"&gid=nadlan";
			}
			// "https://es.govmap.gov.il/TldSearch/api/DetailsByQuery?query=" +
			// appVue.search +
			// "&lyrs=" +
			// searchType +
			// "&gid=nadlan";
			if (searchType == null) {
				appVue.$store.state.searchError = true;
				return;
			}
			if (appVue.search == null || appVue.search == "") {
				appVue.$store.state.searchError = true;
				return;
			}
			
			fetch(url)
				.then((response) => response.json())
				.then((res) => {
					
					if (res.data.hasOwnProperty("SETTLEMENT")) {
						if (res.data["SETTLEMENT"].length > 0) {
							storeObject.baseSearch = "settlement";
							storeObject.levelType = null;
							appVue.$store.state.levelId = null;
							storeObject.baseId = res.data["SETTLEMENT"][0].ObjectID;

							appVue.searchType = "SETTLEMENT";
							appVue.ResultType = "ישוב: ";
							appVue.ResultLabel = res.data["SETTLEMENT"][0].ResultLable;
							appVue.$store.state.ResultLabel =
								res.data["SETTLEMENT"][0].ResultLable;
							var setl_code = res.data["SETTLEMENT"][0].ObjectID;
							appVue.$store.state.setlCode = setl_code;
							const d_url =
								appVue.$store.state.config.s3_page_base +
								"/settlement/buy/" +
								setl_code +
								".json" + 
								"?t=" + new Date().getTime();
							fetch(d_url).then(function (response) {
								const data = response.json();
								data.then(function (e) {
									appVue.$store.state.settlementName = e.settlementName;
									appVue.$store.state.isMain = false;
									appVue.$store.state.similarNeighborhoods =
										e.otherNeighborhoods;
									thisMixin.updatePathQueryParam(
										appVue.$store.state.setlCode,
										"setlCode",
										"settlement",
									);
								});
							});
						}
					} else if (res.data.hasOwnProperty("NEIGHBORHOOD")) {
						if (res.data["NEIGHBORHOOD"].length > 0) {
							storeObject.baseSearch = "neighborhood";
							storeObject.levelType = null;
							appVue.$store.state.levelId = null;
							storeObject.baseId = res.data["NEIGHBORHOOD"][0].ObjectID;

							appVue.searchType = "NEIGHBORHOOD";

							appVue.ResultType = "שכונה: ";
							appVue.ResultLabel = res.data["NEIGHBORHOOD"][0].ResultLable;
							appVue.$store.state.ResultLabel =
								res.data["NEIGHBORHOOD"][0].ResultLable;

							var neigh_id = (neigh_id = res.data["NEIGHBORHOOD"][0].ObjectID);
							if (
								appVue.$store.state.config.search_baseUrl ==
								"https://es.govmap.gov.il/TldSearch"
							) {
								neigh_id =
									appVue.$store.state.neigh[
										res.data["NEIGHBORHOOD"][0].ObjectID
									].UNIQ_ID_OLD;
							}
							const d_url =
								appVue.$store.state.config.s3_page_base +
								"/neighborhood/buy/" +
								neigh_id +
								".json" + 
								"?t=" + new Date().getTime();
							fetch(d_url).then(function (response) {
								const data = response.json();
								data.then(function (e) {
									appVue.$store.state.neighborhoodName = e.neighborhoodName;
									appVue.$store.state.settlementName = e.settlementName;
									appVue.$store.state.setlCode = e.settlementID;
									appVue.$store.state.neighborhoodId = e.neighborhoodId;
									appVue.neighborhoodId = e.neighborhoodId;
									appVue.$store.state.isMain = false;
									thisMixin.updatePathQueryParam(
										appVue.neighborhoodId,
										"neighborhoodId",
										"neighborhood",
									);
								});
							});
						}
					} else if (res.data.hasOwnProperty("KPARCEL_ALL")) {
						if (res.data["KPARCEL_ALL"].length > 0) {
							storeObject.baseSearch = "kparcel";
							storeObject.baseId = res.data["KPARCEL_ALL"][0].ObjectID;

							appVue.searchType = "KPARCEL_ALL";
							appVue.ResultType = "גוש: ";
							appVue.ResultLabel = res.data["KPARCEL_ALL"][0].ResultLable;
							appVue.$store.state.ResultLabel =
								res.data["KPARCEL_ALL"][0].ResultLable;
							var kParcel = res.data["KPARCEL_ALL"][0].ObjectID;
							appVue.$store.state.kParcel = kParcel;
							appVue.$store.state.isMain = false;
							thisMixin.updatePathQueryParam(
								appVue.$store.state.kParcel,
								"kParcel",
								"kparcel_all",
							);

							var d_url = null;
							if (appVue.neighborhoodId != null) {
								d_url =
									appVue.$store.state.config.s3_page_base +
									"/neighborhood/buy/" +
									appVue.neighborhoodId +
									".json" + 
									"?t=" + new Date().getTime();
							}
							if (appVue.setlCode != null) {
								d_url =
									appVue.$store.state.config.s3_page_base +
									"/settlement/buy/" +
									appVue.setlCode +
									".json" + 
									"?t=" + new Date().getTime();
							}
							if (d_url != null) {
								fetch(d_url).then(function (response) {
									const data = response.json();
									data.then(function (e) {
										//set store neighborhood, setlName
										appVue.$store.state.neighborhoodName = e.neighborhoodName;
										appVue.$store.state.settlementName = e.settlementName;
										appVue.$store.state.isMain = false;
										thisMixin.updatePathQueryParam(
											appVue.$store.state.polygonId,
											"polygonId",
											"address",
										);
									});
								});
							}
						}
					} else if (res.data.hasOwnProperty("ADDRESS")) {
						if (res.data["ADDRESS"].length > 0) {
							storeObject.baseSearch = "address";
							storeObject.baseId = res.data["ADDRESS"][0].ObjectID;

							appVue.$store.state.addressId = res.data["ADDRESS"][0].ObjectID;
							var addrId = res.data["ADDRESS"][0].ObjectID;
							thisMixin.updatePathQueryParam(
								appVue.$store.state.addressId,
								"addressId",
								"address",
							);

							var d_url = null;
							if (appVue.neighborhoodId != null) {
								//https://d1pbgh6hzbn1h3.cloudfront.net/backgroundMaps/pages/neighborhood/buy/65209994.json
								d_url =
									appVue.$store.state.config.s3_page_base +
									"/neighborhood/buy/" +
									appVue.neighborhoodId +
									".json" + 
									"?t=" + new Date().getTime();
							}
							if (appVue.setlCode != null) {
								// https://d1pbgh6hzbn1h3.cloudfront.net/backgroundMaps/pages/settlement/buy/5000.json
								d_url =
									appVue.$store.state.config.s3_page_base +
									"/settlement/buy/" +
									appVue.setlCode +
									".json" + 
									"?t=" + new Date().getTime();
							}
							if (d_url != null) {
								fetch(d_url).then(function (response) {
									const data = response.json();
									data.then(function (e) {
										//set store neighborhood, setlName
										appVue.$store.state.neighborhoodName = e.neighborhoodName;
										appVue.$store.state.settlementName = e.settlementName;
										appVue.$store.state.isMain = false;
										thisMixin.updatePathQueryParam(
											appVue.$store.state.polygonId,
											"polygonId",
											"address",
										);
									});
								});
							}
						}
					} else if (res.data.hasOwnProperty("STREET")) {
						if (res.data["STREET"].length > 0) {
							storeObject.baseSearch = "street";
							storeObject.baseId = res.data["STREET"][0].ObjectID;

							appVue.searchType = "STREET";
							appVue.ResultType = "רחוב: ";
							appVue.ResultLabel = res.data["STREET"][0].ResultLable;
							appVue.$store.state.ResultLabel =
								res.data["STREET"][0].ResultLable;
							appVue.$store.state.streetCode = res.data["STREET"][0].ObjectID;
							thisMixin.updatePathQueryParam(
								appVue.$store.state.streetCode,
								"streetCode",
								"street",
							);

							var d_url = null;
							if (appVue.neighborhoodId != null) {
								//https://d1pbgh6hzbn1h3.cloudfront.net/backgroundMaps/pages/neighborhood/buy/65209994.json
								d_url =
									appVue.$store.state.config.s3_page_base +
									"/neighborhood/buy/" +
									appVue.neighborhoodId +
									".json" + 
									"?t=" + new Date().getTime();
							}
							if (appVue.setlCode != null) {
								// https://d1pbgh6hzbn1h3.cloudfront.net/backgroundMaps/pages/settlement/buy/5000.json
								d_url =
									appVue.$store.state.config.s3_page_base +
									"/settlement/buy/" +
									appVue.setlCode +
									".json" + 
									"?t=" + new Date().getTime();
							}
							if (d_url != null) {
								fetch(d_url).then(function (response) {
									const data = response.json();
									data.then(function (e) {
										//set store neighborhood, setlName
										appVue.$store.state.neighborhoodName = e.neighborhoodName;
										appVue.$store.state.settlementName = e.settlementName;
										appVue.$store.state.isMain = false;
										thisMixin.updatePathQueryParam(
											appVue.$store.state.addressId,
											"addressId",
											"address",
										);
									});
								});
							}
						}
					}

					appVue.$store.state.storeObject = storeObject;
				});
		},
		updatePathQueryParam(newParamValue, paramName, urlParamName) {
			const currentParamValue = this.$route.params[paramName]; // Replace 'paramName' with the actual name of your parameter
			if (newParamValue !== currentParamValue) {
				// get the base url domain...
				const baseUrl = window.location.protocol + "//" + window.location.host;
				// generate as "http://localhost:8080/?view=neighborhood_buy&id=65209722&page=deals
				// Construct the query parameters
				const queryParams = new URLSearchParams();
				queryParams.set("view", urlParamName);
				queryParams.set("id", newParamValue);
				queryParams.set("page", "deals");

				// Construct the new URL with the query parameters
				const newPath = `${baseUrl}?${queryParams.toString()}`;
				// Navigate to the new URL using window.location
				window.location.href = newPath;
			}
		},

		mixin_getDealsData(appVue, searchType, code) {
			const _this = this;
			// if no config, load config
			appVue.$store.dispatch("loadConfig").then(() => {
				var url = "";
				var url_type = "";
				if (searchType == "SETTLEMENT") {
					url_type = appVue.$store.state.setl_url;
				} else if (searchType == "NEIGHBORHOOD") {
					url_type = appVue.$store.state.neigh_url;
				} else if (searchType == "STREET") {
					url_type = appVue.$store.state.street_url;
				} else if (searchType == "ADDRESS") {
					url_type = appVue.$store.state.asset_url;
				} else {
					return;
				}

				if (url_type == "") {
					return;
				}

				url =
					appVue.$store.state.config.s3_deals_base +
					url_type +
					code +
					"_" +
					appVue.current +
					".json";

				fetch(url)
					.then((response) => response.json())
					.then((data) => {
						appVue.total = data.total;
						var count_files = data.count_files;
						this.setFancyRows(data);
						data.items.forEach((element) => {
							(element["collapsed"] = true), appVue.deals.push(element);
						});
						if (appVue.current < count_files) {
							appVue.current = appVue.current + 1;
							_this.mixin_getDealsData(appVue, searchType, code);
						}
					});
			});

			// // Set interval until config is loaded
			// let intervalId = setInterval(async function () {
			// 	if (!appVue.$store.state.config.hasOwnProperty("s3_deals_base")) {
			// 		await appVue.$store.dispatch("loadConfig");
			// 	} else {
			// 		clearInterval(intervalId);

			// 		var url = "";
			// 		var url_type = "";
			// 		if (searchType == "SETTLEMENT") {
			// 			url_type = appVue.$store.state.setl_url;
			// 		} else if (searchType == "NEIGHBORHOOD") {
			// 			url_type = appVue.$store.state.neigh_url;
			// 		} else if (searchType == "STREET") {
			// 			url_type = appVue.$store.state.street_url;
			// 		} else if (searchType == "ADDRESS") {
			// 			url_type = appVue.$store.state.asset_url;
			// 		} else {
			// 			return;
			// 		}

			// 		if (url_type == "") {
			// 			return;
			// 		}

			// 		url =
			// 			appVue.$store.state.config.s3_deals_base +
			// 			url_type +
			// 			code +
			// 			"_" +
			// 			appVue.current +
			// 			".json";

			// 		fetch(url)
			// 			.then((response) => response.json())
			// 			.then((data) => {
			// 				appVue.total = data.total;
			// 				var count_files = data.count_files;
			// 				_this.setFancyRows(data);
			// 				data.items.forEach((element) => {
			// 					(element["collapsed"] = true), appVue.deals.push(element);
			// 				});
			// 				if (appVue.current < count_files) {
			// 					appVue.current = appVue.current + 1;
			// 					//_this.mixin_getDealsData(appVue, searchType, code);
			// 				}
			// 			});
			// 	}
			// }, 500);
		},

		mixin_fetchAdditionalDealsData(appVue, searchType) {
			var url = "";
			if (appVue.$store.state.config.s3_deals_base == null) {
				//load config from store (function)
				appVue.$store.dispatch("loadConfig");
			}
			if (
				searchType == "ADDRESS" ||
				searchType == "KPARCEL_ALL" ||
				searchType == "STREET"
			) {
				if (appVue.summaryTypeName == "ישוב") {
					var code = appVue.$store.state.setlCode;
					url =
						appVue.$store.state.config.s3_deals_base +
						appVue.$store.state.setl_url +
						code +
						"_" +
						appVue.current +
					(".json");
				} else if (appVue.summaryTypeName == "שכונה") {
					var code = appVue.$store.state.neighborhoodId;
					url =
						appVue.$store.state.config.s3_deals_base +
						appVue.$store.state.neigh_url +
						code +
						"_" +
						appVue.current +
						".json";
				} else {
					return;
				}
			} else {
				return;
			}
			if (url != "") {
				fetch(url)
					.then((response) => response.json())
					.then((data) => {
						appVue.additional_total = data.total;
						appVue.$store.state.additional_total = data.total;
						var count_files = data.count_files;
						this.setFancyRows(data);
						data.items.forEach((element) => {
							(element["collapsed"] = true),
								appVue.$store.state.addtionalDeals.push(element);
						});
						if (appVue.current < count_files) {
							appVue.current = appVue.current + 1;
							this.mixin_fetchAdditionalDealsData(appVue, searchType);
						}
					});
			}
		},

		async mixin_fetchPageData(appVue, searchType, code, api_base) {
			var url = "";
			const _this = this;
			var storeObject = {};

			//await appVue.$store.dispatch("loadConfig");

			storeObject.baseId = code; // 1
			if (searchType == "SETTLEMENT") {
				storeObject.baseSearch = "settlement"; // 2
			} else if (searchType == "NEIGHBORHOOD") {
				storeObject.baseSearch = "neighborhood"; // 2
			} else if (searchType == "STREET") {
				storeObject.baseSearch = "street"; // 2
			} else if (searchType == "ADDRESS") {
				storeObject.baseSearch = "address"; // 2
			} else if (searchType == "KPARCEL_ALL") {
				storeObject.baseSearch = "kparcel"; // 2
			} else {
				return;
			}

				const types = {
					STREET: "street_id",
					NEIGHBORHOOD: "neigh_id",
					KPARCEL_ALL: "parcel_id",
					ADDRESS: "addr_id",
					POLYGON_ID: "polygon_id",
					SETTLEMENT: "setl_id",
				};

				const api_url = api_base + "/GetInfo";
				const payload = {
					base_name: types[searchType],
					base_id: code,
				};
				const response = await fetch(api_url, {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify(payload),
				});
				const data = await response.json();

				//Keep All those values in store...
				// base_level
				// base_level_id
				// base_name
				// base_id
				if (data.base_level == "neighborhood") {
					appVue.$store.state.base_level = "neighborhoodId";
					appVue.$store.state.base_level_id = data.neigh_id;
					appVue.$store.state.base_name = "neighborhoodId";
					appVue.$store.state.base_id = data.neigh_id;
				} else if (data.base_level == "settlement") {
					appVue.$store.state.base_level = "settlmentID";
					appVue.$store.state.base_level_id = data.setl_id;
					appVue.$store.state.base_name = "settlmentID";
					appVue.$store.state.base_id = data.setl_id;
				}


				// check if refs exists in ref="graph_component"
				if (appVue.$refs.rents_page) {
					if (appVue.$refs.rents_page.$refs.target_container) {
						const targrt_container = appVue.$refs.rents_page.$refs.target_container;
						targrt_container.selectTab(targrt_container.tabs[0]);
						const graph = appVue.$refs.rents_page.$refs.target_container.$refs.graph_component;
						if (graph) {

	
							const searchType = appVue.$route.query.view;
							setTimeout(() => {
								graph.settlementId = data.setl_id;
								graph.settlementName = data.setl_name;
								graph.neighborhoodId = data.neigh_id;
								graph.neighborhoodName = data.neigh_name;
								graph.base_level = data.base_level;
								graph.pageType = searchType;
								graph.initializeChart()
								.then(() => {
									//create grpah
									graph.createChart();
								})
								.catch((error) => {
									console.error("Error initializing chart:", error);
								});
							}, 1);		
						}
					}
					
				}
				

				// check if refs exists in ref="deals_page"
				if (appVue.$refs.deals_page) {
					appVue.$refs.deals_page.fetchData();
					// check if refs exists in ref="graph_component"
					if (appVue.$refs.deals_page.$refs.target_container) {
						const targrt_container = appVue.$refs.deals_page.$refs.target_container;
						targrt_container.selectTab(targrt_container.tabs[0]);
						const graph = appVue.$refs.deals_page.$refs.target_container.$refs.graph_component;
						if (graph) {


							const searchType = appVue.$route.query.view;
							setTimeout(() => {
								graph.settlementId = data.setl_id;
								graph.settlementName = data.setl_name;
								graph.neighborhoodId = data.neigh_id;
								graph.neighborhoodName = data.neigh_name;
								graph.base_level = data.base_level;
								graph.pageType = searchType;
								graph.initializeChart()
								.then(() => {
									//create grpah
									graph.createChart();
								})
								.catch((error) => {
									console.error("Error initializing chart:", error);
								});
							}, 1);

							
						}
					}
					// check if refs exists in ref="additional_deals"
					if (searchType == "ADDRESS" || searchType == "KPARCEL_ALL" || searchType == "STREET")
					{
						if (appVue.$refs.deals_page.$refs.additional_deals) {
							//console.log("refs additional_deals exists");
							//fetch data
							setTimeout(() => {
								appVue.$refs.deals_page.$refs.additional_deals.base_level = appVue.$store.state.base_level
								appVue.$refs.deals_page.$refs.additional_deals.base_level_id = appVue.$store.state.base_level_id;
								appVue.$refs.deals_page.$refs.additional_deals.base_name = appVue.$store.state.base_name;
								appVue.$refs.deals_page.$refs.additional_deals.base_id = appVue.$store.state.base_id;
								appVue.$refs.deals_page.$refs.additional_deals.fetchData();
							}, 10);
						}
					}

				}


				// console.log("base_level", appVue.$store.state.base_level);
				// console.log("base_level_id", appVue.$store.state.base_level_id);
				// console.log("base_name", appVue.$store.state.base_name);
				// console.log("base_id", appVue.$store.state.base_id);

				
				// set appVue.$store.state.neighborhoodId and appVue.$store.state.setlCode

				// addr res :  'addr_id', 'setl_id', 'setl_name', 'street_name', 'street_id', 'house_num', 'entry_letr', 'neigh_id', 'neigh_name'
				// setl res: 'setl_id', 'setl_name'
				// street res: 'setl_id', 'setl_name', 'street_name', 'street_id', 'neigh_id', 'neigh_name'
				// neighborhood res: 'neigh_id', 'neigh_name',  'setl_id', 'setl_name'

				appVue.$store.state.setlCode = data.setl_id;

				if (
					searchType == "ADDRESS" ||
					searchType == "KPARCEL_ALL" ||
					searchType == "STREET"
				) {
					appVue.$store.state.polygonId = data.polygon_id;

					appVue.$store.state.neighborhoodId = data.neigh_id;
					appVue.neighborhoodId = data.neigh_id;
					appVue.neighborhoodName = data.neigh_name;
					appVue.$store.state.neighborhoodName = data.neigh_name;

					appVue.setlCode = data.setl_id;
					appVue.$store.state.setlCode = data.setl_id;
					appVue.settlementName = data.setl_name;
					appVue.$store.state.settlementName = data.setl_name;

					if (data.setl_id != null && data.setl_id != "") {
						storeObject.levelId = data.setl_id;
						storeObject.levelType = "settlement";
					}
					if (data.neigh_id != null && data.neigh_id != "") {
						storeObject.levelId = data.neigh_id;
						storeObject.levelType = "neighborhood";
					}

					//set checkAddress text value (if is address)
					if (searchType == "ADDRESS") {
						appVue.$store.state.addrName = data.addr_name;
					}
					if (searchType == "STREET") {
						appVue.$store.state.streetName = data.street_name;
					}
				}
			//}
			// set Vuex
			appVue.$store.state.storeObject = storeObject;
			appVue.$store.state.loading = false;
		},
		setFancyRows(e) {
			e.items.forEach((element) => {
				element.dealAmount = element.dealAmount.toLocaleString("he-IL") + " ₪";
				// get date
				// exmple: 2023-02-09T02:00:00+02:00
				// format to 'DD/MM/YYYY'
				const date = new Date(element.dealDate);
				const day = date.getDate().toString().padStart(2, "0");
				const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Month is zero-based, so we add 1
				const year = date.getFullYear();
				const formattedDate = `${day}/${month}/${year}`;
				element.dealDate = formattedDate;
				if (element.hasOwnProperty("prevDeals")) {
					element.prevDeals.forEach((i) => {
						const date = new Date(i.dealDate);
						const day = date.getDate().toString().padStart(2, "0");
						const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Month is zero-based, so we add 1
						const year = date.getFullYear();
						const formattedDate = `${day}/${month}/${year}`;
						i.dealDate = formattedDate;
					});
				}
				//trend
				let rate = element.trend.rate;
				let years = element.trend.years;
				let trend = `${rate}% ב ${years} שנים`;
				if (
					element.trend.hasOwnProperty("rate") == false ||
					element.trend.rate == 0
				) {
					element.trend_text = "";
				} else {
					element.trend_text = trend;
				}
				//adrress
				if (element.address == 0) {
					element.address = "";
				}
			});
		},


		mixin_convertToHebrew(appVue) {
			let convertedText = '';
			for (let char of appVue.search) {
			  if (this.englishToHebrew[char]) {
				convertedText += this.englishToHebrew[char];
			  } else {
				convertedText += char;
			  }
			}
			appVue.search = convertedText;
		},

		mixin_setSearchBox(appVue, inputElement1) {
			var _this = this;
			var testMode = false;
			var searchType = 1;
			(function () {
				function r(e, n, t) {
					function o(i, f) {
						if (!n[i]) {
							if (!e[i]) {
								var c = "function" == typeof require && require;
								if (!f && c) return c(i, !0);
								if (u) return u(i, !0);
								var a = new Error("Cannot find module '" + i + "'");
								throw ((a.code = "MODULE_NOT_FOUND"), a);
							}
							var p = (n[i] = { exports: {} });
							e[i][0].call(
								p.exports,
								function (r) {
									var n = e[i][1][r];
									return o(n || r);
								},
								p,
								p.exports,
								r,
								e,
								n,
								t,
							);
						}
						return n[i].exports;
					}
					for (
						var u = "function" == typeof require && require, i = 0;
						i < t.length;
						i++
					)
						o(t[i]);
					return o;
				}
				return r;
			})()(
				{
					1: [
						function (require, module, exports) {
							"use strict";
							var _slicedToArray = (function () {
								function sliceIterator(arr, i) {
									var _arr = [];
									var _n = true;
									var _d = false;
									var _e = undefined;
									try {
										for (
											var _i = arr[Symbol.iterator](), _s;
											!(_n = (_s = _i.next()).done);
											_n = true
										) {
											_arr.push(_s.value);
											if (i && _arr.length === i) break;
										}
									} catch (err) {
										_d = true;
										_e = err;
									} finally {
										try {
											if (!_n && _i["return"]) _i["return"]();
										} finally {
											if (_d) throw _e;
										}
									}
									return _arr;
								}
								return function (arr, i) {
									if (Array.isArray(arr)) {
										return arr;
									} else if (Symbol.iterator in Object(arr)) {
										return sliceIterator(arr, i);
									} else {
										throw new TypeError(
											"Invalid attempt to destructure non-iterable instance",
										);
									}
								};
							})();
							Object.defineProperty(exports, "__esModule", { value: true });
							
							var src_baseUrl = appVue.$store.state.config.search_baseUrl;
							//var src_baseUrl = appVue.$store.state.config.search_baseUrl_nadlan;
							
							var options1 = null;
							// check if inputElement1.id == 'myInput_neigh'
							if (inputElement1.id == "myInput_neigh") {
								options1 = {
									searchCode: 1,
									url: src_baseUrl,
									subjectId: 0,
									//gid: "",
									debounce: 200,
									minLength: 1,
									placeholder: "חיפוש שכונה",
									clearOnClick: false,
									onInput: function onInput(res) {
										options1.subjectId = 4;
										// if (!testMode) {
										// 	options1.gid = "nadlan";
										// }
									},
									onSelect: function onSelect(res) {
										var searchTypes = {
											NEIGHBORHOOD: 4,
											STREET: 2,
											ADDRESS: 1,
											SETTLEMENT: 8,
											KPARCEL_ALL: 16384,
										};
										if (src_baseUrl == "https://www.nadlan.gov.il/TldSearch") {
											searchTypes = {
												SETTLEMENT: 0,
												NEIGHBORHOOD: 1,
												STREET: 2,
												ADDRESS: 3,
												KPARCEL_ALL: 4,
											};
										}
										searchType = searchTypes[res.l];

										appVue.$store.state.searchType = searchType;
										appVue.$store.state.searchTypeText = res.l;
										appVue.$store.state.neigh_comp_search = res.query;
									},
								};
							} else if (inputElement1.id == "myInput_addr") {
								options1 = {
									searchCode: 1,
									url: src_baseUrl,
									subjectId: 0,
									//gid: "nadlan",
									debounce: 200,
									minLength: 1,
									placeholder: "חפשו את הכתובת עליה תרצו עדכונים",
									clearOnClick: false,
									onInput: function onInput(res) {
										//
										//options1.subjectId = 1;
										options1.subjectId = 16399;
										// if (!testMode) {
										// 	options1.gid = "nadlan";
										// }
									},
									onSelect: async function onSelect(res) {
										var addr_obj = {
											addressName: res.query,
											addressId: res.k,
											addressType: res.l,
											// polygonId: data.polygon_id,
											// settlementId: data.setl_id,
											// settlementName: data.setl_name,
											// neighborhoodId: data.neigh_id,
											// neighborhoodName: data.neigh_name
										};
										if (appVue.$store.state.config.search_baseUrl == "https://es.govmap.gov.il/TldSearch") {
											if (addr_obj.addressType == "NEIGHBORHOOD") {
												// convert neigh id
												
												addr_obj.addressId = appVue.$store.state.neigh[
													addr_obj.addressId
																].UNIQ_ID_OLD;
											}
										}
										appVue.addrToAdd = addr_obj;
										var searchTypes = {
											NEIGHBORHOOD: 4,
											STREET: 2,
											ADDRESS: 1,
											SETTLEMENT: 8,
											KPARCEL_ALL: 16384,
										};
										if (src_baseUrl == "https://www.nadlan.gov.il/TldSearch") {
											searchTypes = {
												SETTLEMENT: 0,
												NEIGHBORHOOD: 1,
												STREET: 2,
												ADDRESS: 3,
												KPARCEL_ALL: 4,
											};
										}
										searchType = searchTypes[res.l];

										appVue.$store.state.searchType = searchType;
										appVue.$store.state.searchTypeText = res.l;
										appVue.$store.state.addr_comp_search = res.query;
									},
									onAutocompleteResult: function onAutocompleteResult(acResult) {
										
										//REMOVE PROPERTY
										delete acResult.res.SETTLEMENT;
									}
								};
							} else {
								options1 = {
									searchCode: 1,
									url: src_baseUrl,
									subjectId: 0,
									//gid: "",
									debounce: 200,
									minLength: 1,
									placeholder: "הקלידו כתובת / ישוב / שכונה / רחוב",
									clearOnClick: false,
									onInput: function onInput(res) {
										options1.subjectId = 16399;
										// if (!testMode) {
										// 	options1.gid = "nadlan";
										// }
									},
									onSelect: function onSelect(res) {
										
										var searchTypes = {
											NEIGHBORHOOD: 4,
											STREET: 2,
											ADDRESS: 1,
											SETTLEMENT: 8,
											KPARCEL_ALL: 16384,
										};
										if (src_baseUrl == "https://www.nadlan.gov.il/TldSearch") {
											searchTypes = {
												SETTLEMENT: 0,
												NEIGHBORHOOD: 1,
												STREET: 2,
												ADDRESS: 3,
												KPARCEL_ALL: 4,
											};
										}
										////
										searchType = searchTypes[res.l];
										// set store.search

										appVue.$store.state.searchType = searchType;
										appVue.$store.state.searchTypeText = res.l;
										appVue.$store.state.search = res.query;

										//search!
										_this.mixin_showResults(appVue);
									},
								};
							}
							if (inputElement1 == null) {
								////
							} else {
								autocomplete(inputElement1, options1);
							}
						},
						{},
					],
				},
				{},
				[1],
			);
		},


		mixin_setNiceToMeets(appVue, locationType) {
			const locationDict = {
			neighborhood: "שכונה",
			settlement: "ישוב",
			};
			var locationNameHeb = locationDict[locationType];
			appVue.niceToMeets = [
			{
				name: "nadlan",
				icon: "/images/indexes/indexes.svg",
				title: 'מדדי נדל"ן',
				mapLayerName: "",
				items: [
				{
					name: "buyAllRooms",
					title: "מחיר חציוני לנכס",
					display: appVue.$store.state.lastYearAvgPrice   > 0
					? appVue.$store.state.lastYearAvgPrice.toLocaleString() + " ₪"
					: 'לא ידוע',
					icon: "/images/indexes/cols/home-price.svg",
					selectedInfo: "nadlan",
				},
				{
					name: "rentAllRooms",
					title: "מחיר שכירות חציוני",
					display: appVue.additional.RealEstateIndices.RentAllRooms   > 0
					? appVue.additional.RealEstateIndices.RentAllRooms.toLocaleString() + " ₪"
					: 'לא ידוע',
					icon: "/images/indexes/cols/avg-price.svg",
					selectedInfo: "nadlan",
				},
				{
					name: "luxury",
					title: locationType === 'neighborhood' ? "ציון יוקר של השכונה" : "ציון יוקר של הישוב",
					selectedInfo: "nadlan",
					display: appVue.gaugeValue == 0 ? 'לא ידוע' : ' '
				},
				{
					name: "annualReturn",
					title: "תשואת שכירות חציונית",
					display: (appVue.$store.state.Yield != null ? appVue.$store.state.Yield.toFixed(2) : 'לא יודע'),
					icon: "/images/indexes/cols/arenda-price.svg",
					selectedInfo: "nadlan",
				},
				{
					title: "עליית מחירים ב-5 שנים",
					display: appVue.additional.RealEstateIndices.AveragePriceIncrease   > 0
					? appVue.additional.RealEstateIndices.AveragePriceIncrease + '%' 
					: 'לא ידוע',
					icon: "/images/indexes/cols/elite-price.svg",
					selectedInfo: "nadlan",
				},
				],
				nadlan_items: [
				{
					name: 'buy5Rooms',
					title: 'מחיר חציוני',
					icon: '/images/indexes/summary-5.svg',
					display: appVue.$store.state.lastYearAvgPrice_5 > 0
					? appVue.$store.state.lastYearAvgPrice_5.toLocaleString() + " ₪"
					: 'לא ידוע',
				},
				{
					name: 'buy4Rooms',
					title: 'מחיר חציוני',
					icon: '/images/indexes/summary-4.svg',
					display: appVue.$store.state.lastYearAvgPrice_4   > 0
					? appVue.$store.state.lastYearAvgPrice_4.toLocaleString() + " ₪"
					: 'לא ידוע',
				},
				{
					name: 'buy3Rooms',
					title: 'מחיר חציוני',
					icon: '/images/indexes/summary-3.svg',
					display: appVue.$store.state.lastYearAvgPrice_3   > 0
					? appVue.$store.state.lastYearAvgPrice_3.toLocaleString() + " ₪"
					: 'לא ידוע',
				},
				{
					name: 'SquareMeter',
					title: ' מחיר חציוני למ"ר ',
					icon: '/images/indexes/summary-avg.svg',
					display: appVue.additional.RealEstateIndices.SquareMeter   > 0
					? parseInt(appVue.additional.RealEstateIndices.SquareMeter).toLocaleString() + " ₪"
					: 'לא ידוע',
				}
				]
			},
			{
				name: "education",
				icon: "/images/education/education.svg",
				title: "חינוך",
				mapLayerName: "kidsGardensAndSchools",
				items: [
					{
						icon: "/images/education/school.svg",
						title: "בתי ספר",
						selectedInfo: "schools",
						arrow: "/images/education/arrow-orange.svg",
						arrowDown:
							"/images/education/arrow-orange-down.svg",
						display: appVue.schoolsItemsAll.length,
						table: {
							id: "schools_transition",
							headers: [
								"מספר סידורי",
								"שם הבית ספר",
								"שלב",
								"סוג חינוך",
								"פיקוח",
								"מגזר",
								"כתובת",
							],
							data: appVue.schoolsItemsAll.map(
								(item, index) => ({
									index: index + 1,
									name: item.name,
									stage: item.stage,
									educationType: item.educationType,
									supervisionType: item.supervisionType,
									migzar: item.migzar,
									address: item.address,
									x: item.x,
									y: item.y,
								}),
							),
						},
					},
					{
						icon: "/images/education/kindergarten.svg",
						title: "גני ילדים ומעונות",
						selectedInfo: "kindergardens",
						arrow: "/images/education/arrow-red.svg",
						arrowDown: "/images/education/arrow-red-down.svg",
						display: appVue.kidsGardensAll.length,
						table: {
							id: "kindergardens_transition",
							headers: [
								"מספר סידורי",
								"שם",
								"כתובת",
								"פיקוח",
								"סוג חינוך",
								"מגזר",
							],
							data: appVue.kidsGardensAll.map(
								(item, index) => ({
									index: index + 1,
									name: item.name,
									address: item.address,
									supervisionType: item.supervisionType,
									educationType: item.educationType,
									migzar: item.migzar,
									x: item.x,
									y: item.y,
								}),
							),
						},
					},
					{
						icon: "/images/education/theatre.svg",
						title: "מוסדות חינוך בלתי פורמלי",
						indexesFonts: 'מתנ"סים, תנועות נוער',
						selectedInfo: "community_centers",
						arrow: "/images/education/arrow-blue.svg",
						arrowDown:
							"/images/education/arrow-blue-down.svg",
						display:
							appVue.nearByObjects.community.centers.length,
						table: {
							id: "matnasim_transition",
							headers: [
								"מספר סידורי",
								"שם מוסד",
								"סוג מוסד",
								"כתובת",
							],
							data: appVue.nearByObjects.community.centers.map(
								(item, index) => ({
									index: index + 1,
									name: item.name,
									description: item.description,
									address: item.address,
									x: item.x,
									y: item.y,
								}),
							),
						},
					},
					{
						icon: "/images/education/man.svg",
						title: "מרחק ממוצע מבית ספר",
						selectedInfo: "schools",
						display:
							parseInt(
								appVue.additional.WalkingAvgDistance.Schools,
							).toLocaleString() + " מטר ",
						table: null,
					},
				],
			},
			{
				name: "parks",
				icon: "/images/parks/parks.svg",
				title: "גינות ופארקים",
				mapLayerName: "gardensAndParks",
				items: [
					{
						icon: "/images/parks/green-space.svg",
						title: "שטחים ירוקים",
						display:
							parseInt(
								Number(
									appVue.additional.GreenAreasSum,
								).toFixed(),
							).toLocaleString() + ' מ"ר',
						table: null,
					},
					{
						icon: "/images/parks/parks_and_gardens.svg",
						title: "פארקים וגינות ציבוריות",
						display: appVue.parksItemsAll.length,
						selectedInfo: "parks",
						table: {
							id: "green_areas_transition",
							headers: ["מספר סידורי", "שם", "סוג", "כתובת"],
							data: appVue.nearByObjects.gardensAndParks.map(
								(item, index) => ({
									index: index + 1,
									name: item.name,
									description: item.description,
									address: item.address,
									x: item.x,
									y: item.y,
								}),
							),
						},
						arrow: "/images/education/arrow-orange.svg",
						arrowDown:
							"/images/education/arrow-orange-down.svg",
					},
					// {
					// 	icon: "/images/parks/distances.svg",
					// 	title: "מרחק ממוצע מריאה ירוקה",
					// 	display:
					// 		parseInt(
					// 			appVue.additional.WalkingAvgDistance
					// 				.NaturalGreenAreas,
					// 		).toLocaleString() + " מטר ",
					// 	table: null,
					// },
					{
						icon: "/images/parks/distances.svg",
						title: "מרחק ממוצע לגינה או פארק",
						selectedInfo: "parks",
						display:
							parseInt(
								appVue.additional.WalkingAvgDistance.Parks,
							).toLocaleString() + " מטר",
						table: null,
					},
				],
			},
			{
				name: "services",
				icon: "/images/services/services.svg",
				title: "שירותים, מסחר ובילוי",
				mapLayerName: "arrangements",
				items: [
					{
						icon: "/images/services/clinics.svg",
						title: "מוסדות ציבור",
						display:
							appVue.nearByObjects.community.clinics.length,
						selectedInfo: "clinics",
						arrow: "/images/services/arrow-green.svg",
						arrowDown:
							"/images/services/arrow-green-down.svg",
						table: {
							id: "public_institutes_transition",
							headers: [
								"מספר סידורי",
								"שם מוסד",
								"סוג מוסד",
								"כתובת",
							],
							data: appVue.nearByObjects.community.clinics.map(
								(item, index) => ({
									index: index + 1,
									name: item.name,
									description: item.description,
									address: item.address,
									x: item.x,
									y: item.y,
								}),
							),
						},
						arrow: "/images/education/arrow-orange.svg",
						arrowDown:
							"/images/education/arrow-orange-down.svg",
					},
					{
						icon: "/images/services/public-institutes.svg",
						title: "מוסדות קהילתיים",
						display:
							appVue.nearByObjects.community.centers.length,
						selectedInfo: "centers",
						arrow: "/images/services/arrow-violet.svg",
						arrowDown:
							"/images/services/arrow-violet-down.svg",
						table: {
							id: "community_centers_transition",
							headers: [
								"מספר סידורי",
								"שם מוסד",
								"סוג מוסד",
								"כתובת",
							],
							data: appVue.nearByObjects.community.centers.map(
								(item, index) => ({
									index: index + 1,
									name: item.name,
									description: item.description,
									address: item.address,
									x: item.x,
									y: item.y,
								}),
							),
						},
						arrow: "/images/education/arrow-orange.svg",
						arrowDown:
							"/images/education/arrow-orange-down.svg",
					},
					{
						icon: "/images/services/religious-institutes.svg",
						title: "מוסדות דת",
						display:
							appVue.nearByObjects.community.religionPoints
								.length,
						selectedInfo: "religionPoints",
						arrow: "/images/services/arrow-red.svg",
						arrowDown: "/images/services/arrow-red-down.svg",
						table: {
							id: "religious_institutes_transition",
							headers: [
								"מספר סידורי",
								"שם מוסד",
								"סוג מוסד",
								"כתובת",
							],
							data: appVue.nearByObjects.community.religionPoints.map(
								(item, index) => ({
									index: index + 1,
									name: item.name,
									description: item.description,
									address: item.address,
									x: item.x,
									y: item.y,
								}),
							),
						},
						arrow: "/images/education/arrow-orange.svg",
						arrowDown:
							"/images/education/arrow-orange-down.svg",
					},
					// {
					// 	icon: "/images/services/walking-distance.svg",
					// 	title: "מרחק ממוצע למבנה ציבור",
					// 	display:
					// 		appVue.additional.WalkingAvgDistance.Shopping,
					// 	table: null,
					// },
				],
			},
			{
				name: "transport",
				icon: "/images/transport/transport.svg",
				title: "תחבורה ונגישות",

				mapLayerName: "busStations",
				items: [
					{
						icon: "/images/transport/bus.svg",
						title: "קווי אוטובוס המגיעים ל" + locationNameHeb,
						display:
							appVue.additional.Transportation.BusLinesCount,
						selectedInfo: "transport",
						arrow: "/images/education/arrow-orange.svg",
						arrowDown:
							"/images/education/arrow-orange-down.svg",
						table: {
							id: "bus_lines_transition",
							//מספר סידורי	מספר תחנה	שם	מיקום	הצג במפה
							headers: [
								"מספר סידורי",
								"מספר תחנה",
								"שם",
								"מיקום",
								"הצג במפה",
							],
							data: appVue.additional.Transportation.BusStationsList.map(
								(item, index) => ({
									index: index + 1,
									stop_code: item.stop_code,
									name: item.name,
									address: item.address,
									groupedRoutes: item.groupedRoutes,
									x: item.x,
									y: item.y,
								}),
							),
						},
					},
					{
						icon: "/images/transport/point.svg",
						title: "תחנות וקווי אוטובוס",
						display:
							appVue.additional.Transportation
								.BusStationsCount,
						selectedInfo: "transport",
						arrow: "/images/education/arrow-red.svg",
						arrowDown: "/images/education/arrow-red-down.svg",
						table: {},
					},
					// {
					// 	icon: "/images/transport/parking.svg",
					// 	title: "חניונים ציבוריים באיזור",
					// 	display: appVue.additional.TransportationGlobal?.ParkingLotsCount ?? 0,
					// 	table: null,
					// },
				],
			},
			{
				name: "demography",
				icon: "/images/demography/demography.svg",
				title: "דמוגרפיה",
				mapLayerName: "demography",
				items: [
					{
						icon: "/images/demography/academic.svg",
						title: "אחוז אקדמאים ביישוב",
						display:
							appVue.additional.Demography.AcademicsInCity.toLocaleString() +
							"%",
						table: null,
					},
					{
						icon: "/images/demography/children.svg",
						title: "ילדים למשק בית",
						display: Number(
							appVue.additional.Demography.AvgChild.toFixed(
								1,
							),
						),
						table: null,
					},
					{
						icon: "/images/demography/chart.svg",
						title: "שיוך מגזרי",
						display: appVue.additional.Demography.Sector,
						table: null,
					},
				],
			},
			{
				name: "environment",
				icon: "/images/environment/environment.svg",
				title: "מדדי איכות הסביבה",
				mapLayerName: "environment",
				items: [
					{
						icon: "/images/environment/status-green.svg",
						title: "מדד זיהום אויר בזמן אמת",
						selectedInfo: "env",
						arrow: "/images/education/arrow-orange.svg",
						arrowDown:
							"/images/education/arrow-orange-down.svg",
						display: 1,
						link: "https://air.sviva.gov.il/",
						table: null,
					},
					{
						icon: "/images/environment/radio.svg",
						title: "אנטנות סלולריות",
						display:
							appVue.additional.Environment.CellActiveCount,
						selectedInfo: "cell",
						arrow: "/images/education/arrow-red.svg",
						arrowDown: "/images/education/arrow-red-down.svg",
						table: {
							id: "cell_transition",
							headers: [
								"מספר סידורי",
								"כתובת",
								"תאריך הפעלה",
								"סוג",
								"רשיון",
								"עוצמת קרינה",
							],
							data: appVue.additional.Environment.CellActives.map(
								(item, index) => ({
									index: index + 1,
									address: item.Address,
									hafalaDate: item.HafalaDate,
									type: item.Type,
									permit: item.Permit,
									intensity: item.Intensity,
								}),
							),
						},
					},
					{
						icon: "/images/environment/factory.svg",
						title: "פליטות לאוויר ממפעלים",
						display: appVue.$store.state.svivaNiturAirList.length,
						selectedInfo: "mifal",
						arrow: "/images/education/arrow-blue.svg",
						arrowDown:
							"/images/education/arrow-blue-down.svg",
						table: {
							id: "env_transition",
							headers: [
								"מספר סידורי",
								"שם מפעל",
								"ישוב",
								"קישור",
							],
							data: appVue.$store.state.svivaNiturAirList.map(
								(item, index) => ({
									index: index + 1,
									name: item.Mifal.trimEnd(),
									yishuv: item.Yishuv,
									link: item.Link,	
								}),
							),
						},
					},
				],
			},
			];

			// Add or modify items based on locationType
			if (locationType === 'neighborhood') {
				// Add neighborhood-specific items
				appVue.niceToMeets.find(item => item.name === "parks").items.push({
				icon: "/images/parks/distances.svg",
				title: "מרחק ממוצע מריאה ירוקה",
				display: parseInt(appVue.additional.WalkingAvgDistance.NaturalGreenAreas).toLocaleString() + " מטר ",
				table: null,
				});

				appVue.niceToMeets.find(item => item.name === "services").items.push({
				icon: "/images/services/walking-distance.svg",
				title: "מרחק ממוצע למבנה ציבור",
				display: appVue.additional.WalkingAvgDistance.Shopping,
				table: null,
				});

				appVue.niceToMeets.find(item => item.name === "transport").items.push(
				{
					icon: "/images/transport/parking.svg",
					title: "חניונים ציבוריים באיזור",
					display: appVue.additional.TransportationGlobal?.ParkingLotsCount ?? 0,
					table: null,
				},
				{
					icon: "/images/transport/point.svg",
					title: "מרחק ממוצע לתחנת אוטובוס",
					display: parseInt(appVue.additional.TransportationGlobal?.AvgBusDistance ?? 0).toLocaleString() + " מטר",
					table: null,
				}
				);

				appVue.niceToMeets.find(item => item.name === "demography").items.unshift(
				{
					icon: "/images/demography/money.svg",
					title: "הכנסה חציונית למשק בית",
					display: parseInt(appVue.additional.Demography.MedianSetlIncome).toLocaleString() + " ₪",
					table: null,
				},
				{
					icon: "/images/demography/school.svg",
					title: "אחוז אקדמאים",
					display: parseInt(appVue.additional.Demography.AcademicsInNeighborhood).toLocaleString() + "%",
					table: null,
				}
				);
			} 
			else if (locationType === 'settlement') {
				// Remove or modify settlement-specific items
				const updateSection = (sectionName, filterFunction) => {
				const section = appVue.niceToMeets.find(item => item.name === sectionName);
				if (section && section.items) {
					section.items = section.items.filter(filterFunction);
				}
				};

				updateSection("parks", item => item.title !== "מרחק ממוצע מריאה ירוקה");
				updateSection("services", item => item.title !== "מרחק ממוצע למבנה ציבור");
				updateSection("transport", item => !["חניונים ציבוריים באיזור", "מרחק ממוצע לתחנת אוטובוס"].includes(item.title));
				updateSection("demography", item => !["הכנסה חציונית למשק בית", "אחוז אקדמאים"].includes(item.title));
			}
		},

		mixin_setTrendsData(appVue, e) {
			//get settlementID
			appVue.$store.state.setlCode = e.settlementID;
			//otherNeighborhoods
			appVue.$store.state.similarNeighborhoods = e.otherNeighborhoods;
			appVue.$store.state.similarStreets = e.otherNeighborhoodStreets;
			if (
				appVue.$store.state.similarNeighborhoods.length == 0 &&
				//(appVue.$route.name.startsWith("neighborhood") ||
				(appVue.$route.query.view.startsWith("neighborhood") ||
					//appVue.$route.name.startsWith("settlement"))
					appVue.$route.query.view.startsWith("settlement"))
			) {
				//collect similarNeighborhoods from settlement

				const d_url =
					appVue.$store.state.config.s3_page_base +
					"/settlement/buy/" +
					appVue.$store.state.setlCode +
					".json" + 
					"?t=" + new Date().getTime();
				fetch(d_url).then(function (response) {
					const data = response.json();
					data.then(function (e) {
						var the_page = null;
						if (appVue.$refs.hasOwnProperty("rents_page")) {
							the_page = appVue.$refs.rents_page;
						}
						if (appVue.$refs.hasOwnProperty("deals_page")) {
							the_page = appVue.$refs.deals_page;
						}
						//if (the_page.$refs.additional_deal != null) {
						// if has additional_deal (ref)
						if (the_page != null) {
							if (the_page.$refs.hasOwnProperty("additional_deals")) {
								if (the_page.$refs.additional_deals.$refs.neigh_scroller != null) {
									the_page.$refs.additional_deals.$refs.neigh_scroller.similarNeighborhoods =
										e.otherNeighborhoods;
								}
							}
						}

					});
				});
			}
			var rooms = e.trends.rooms;
			appVue.$store.state.luxury = e.trends.indexes.luxury;
			appVue.$store.state.priceIncreases = e.trends.indexes.priceIncreases;
			//convert to number (if appVue.$store.state.priceIncreases is not null)
			if (appVue.$store.state.priceIncreases != null) {
				appVue.$store.state.priceIncreases = Number(appVue.$store.state.priceIncreases);
			}	
			appVue.$store.state.Yield = e.trends.indexes.yield;

			appVue.$store.state.lastQuarterlyAvgPricelastQuarterlyAvgPrice =
				rooms[3].summary.lastQuarterlyAvgPrice;
			appVue.$store.state.lastQuarterlyAvgPrice_3 =
				rooms[0].summary.lastQuarterlyAvgPrice;
			appVue.$store.state.lastQuarterlyAvgPrice_4 =
				rooms[1].summary.lastQuarterlyAvgPrice;
			appVue.$store.state.lastQuarterlyAvgPrice_5 =
				rooms[2].summary.lastQuarterlyAvgPrice;

			//lastYearAvgPrice
			//appVue.$store.state.lastYearAvgPrice = rooms[3].summary.lastYearAvgPrice;
			// all rooms
			const gr_data = e.trends.rooms[3].graphData;
			const summary = e.trends.rooms[3].summary;
			if (summary.lastYearAvgPrice != null) {
				appVue.$store.state.lastYearAvgPrice = summary.lastYearAvgPrice;
			}
			else{
				var  lastIndex = 0;
				lastIndex = gr_data.findIndex(price =>  price.neighborhoodPrice > 0); 
				if (!gr_data.some(num => num > 0)) {
					lastIndex = 1;
				}
				appVue.$store.state.lastYearAvgPrice = gr_data[lastIndex].neighborhoodPrice;
			}






			// check if url route is buy (/buy/pricing) or rent (/rent/pricing)...
			//const url_path = appVue.$route.path;
			const url_path = window.location.href;

			if (url_path.includes("rent")) {
				const gr_data = e.trends.rooms[3].graphData;


				
				appVue.$store.state.lastYearAvgSetlPrice =
					//gr_data[gr_data.length - 1].settlementPrice;
					gr_data[0].settlementPrice;
			}

			appVue.$store.state.lastYearAvgPrice_3 =
				rooms[0].summary.lastYearAvgPrice;
			if (appVue.$store.state.lastYearAvgPrice_3 == null) {
				var months_data = rooms[0].graphData;
				// [
				// 	{
				// 		"neighborhoodPrice": null,
				// 		"settlementPrice": null,
				// 		"countryPrice": null,
				// 		"year": 2024,
				// 		"month": 9
				// 	},
				// 	{
				// 		"neighborhoodPrice": null,
				// 		"settlementPrice": 5000,
				// 		"countryPrice": 3600,
				// 		"year": 2024,
				// 		"month": 6
				// 	},
				// 	{
				// 		"neighborhoodPrice": null,
				// 		"settlementPrice": 4900,
				// 		"countryPrice": 3900,
				// 		"year": 2024,
				// 		"month": 3
				// 	},
				// 	{
				// 		"neighborhoodPrice": null,
				// 		"settlementPrice": 5000,
				// 		"countryPrice": 3950,
				// 		"year": 2023,
				// 		"month": 12
				// 	},
				// 	{
				// 		"neighborhoodPrice": null,
				// 		"settlementPrice": 5000,
				// 		"countryPrice": 3925,
				// 		"year": 2023,
				// 		"month": 9
				// 	},
				// 	{
				// 		"neighborhoodPrice": null,
				// 		"settlementPrice": 5300,
				// 		"countryPrice": 3900,
				// 		"year": 2023,
				// 		"month": 6
				// 	},
				// 	{
				// 		"neighborhoodPrice": null,
				// 		"settlementPrice": 4800,
				// 		"countryPrice": 3750,
				// 		"year": 2023,
				// 		"month": 3
				// 	},
				// 	{
				// 		"neighborhoodPrice": null,
				// 		"settlementPrice": 4800,
				// 		"countryPrice": 3575,
				// 		"year": 2022,
				// 		"month": 12
				// 	},
				// 	{
				// 		"neighborhoodPrice": null,
				// 		"settlementPrice": 4800,
				// 		"countryPrice": 3525,
				// 		"year": 2022,
				// 		"month": 9
				// 	},
				// 	{
				// 		"neighborhoodPrice": null,
				// 		"settlementPrice": 4800,
				// 		"countryPrice": 3450,
				// 		"year": 2022,
				// 		"month": 6
				// 	},
				// 	{
				// 		"neighborhoodPrice": null,
				// 		"settlementPrice": 4500,
				// 		"countryPrice": 3495,
				// 		"year": 2022,
				// 		"month": 3
				// 	},
				// 	{
				// 		"neighborhoodPrice": null,
				// 		"settlementPrice": null,
				// 		"countryPrice": null,
				// 		"year": 2021,
				// 		"month": 12
				// 	},
				// 	{
				// 		"neighborhoodPrice": null,
				// 		"settlementPrice": 4299,
				// 		"countryPrice": 3542,
				// 		"year": 2021,
				// 		"month": 9
				// 	},
				// 	{
				// 		"neighborhoodPrice": null,
				// 		"settlementPrice": null,
				// 		"countryPrice": null,
				// 		"year": 2021,
				// 		"month": 6
				// 	},
				// 	{
				// 		"neighborhoodPrice": null,
				// 		"settlementPrice": 4190,
				// 		"countryPrice": 3373,
				// 		"year": 2021,
				// 		"month": 3
				// 	},
				// 	{
				// 		"neighborhoodPrice": null,
				// 		"settlementPrice": null,
				// 		"countryPrice": null,
				// 		"year": 2020,
				// 		"month": 12
				// 	},
				// 	{
				// 		"neighborhoodPrice": null,
				// 		"settlementPrice": null,
				// 		"countryPrice": 3198,
				// 		"year": 2020,
				// 		"month": 9
				// 	},
				// 	{
				// 		"neighborhoodPrice": null,
				// 		"settlementPrice": null,
				// 		"countryPrice": null,
				// 		"year": 2020,
				// 		"month": 6
				// 	},
				// 	{
				// 		"neighborhoodPrice": null,
				// 		"settlementPrice": 4014,
				// 		"countryPrice": 3345,
				// 		"year": 2020,
				// 		"month": 3
				// 	},
				// 	{
				// 		"neighborhoodPrice": null,
				// 		"settlementPrice": null,
				// 		"countryPrice": null,
				// 		"year": 2019,
				// 		"month": 12
				// 	},
				// 	{
				// 		"neighborhoodPrice": null,
				// 		"settlementPrice": 4017,
				// 		"countryPrice": 3363,
				// 		"year": 2019,
				// 		"month": 9
				// 	},
				// 	{
				// 		"neighborhoodPrice": null,
				// 		"settlementPrice": null,
				// 		"countryPrice": null,
				// 		"year": 2019,
				// 		"month": 6
				// 	}
				// ]
				// get the last 12 months prices avg
				var sum = 0;
				var count = 0;
				for (var i = 0; i < months_data.length; i++) {
					if (months_data[i].neighborhoodPrice != null) {
						sum += months_data[i].neighborhoodPrice;
						count++;
					}
				}
			}


			appVue.$store.state.lastYearAvgPrice_4 =
				rooms[1].summary.lastYearAvgPrice;
			if (appVue.$store.state.lastYearAvgPrice_4 == null) {
				var months_data = rooms[1].graphData;
				// get the last 12 months prices avg
				var sum = 0;
				var count = 0;
				for (var i = 0; i < months_data.length; i++) {
					if (months_data[i].neighborhoodPrice != null) {
						sum += months_data[i].neighborhoodPrice;
						count++;
					}
				}
				appVue.$store.state.lastYearAvgPrice_4 = sum / count;
			}
			appVue.$store.state.lastYearAvgPrice_5 = rooms[2].summary.lastYearAvgPrice;
			if (appVue.$store.state.lastYearAvgPrice_5 == null) {
				var months_data = rooms[2].graphData;
				// get the last 12 months prices avg
				var sum = 0;
				var count = 0;
				for (var i = 0; i < months_data.length; i++) {
					if (months_data[i].neighborhoodPrice != null) {
						sum += months_data[i].neighborhoodPrice;
						count++;
					}
				}
				appVue.$store.state.lastYearAvgPrice_5 = sum / count;
			}

			appVue.$store.state.priceDifferencePercentage =
				rooms[3].summary.priceDifferencePercentage;
			appVue.$store.state.priceDifferencePercentage_3 =
				rooms[0].summary.priceDifferencePercentage;
			appVue.$store.state.priceDifferencePercentage_4 =
				rooms[1].summary.priceDifferencePercentage;
			appVue.$store.state.priceDifferencePercentage_5 =
				rooms[2].summary.priceDifferencePercentage;
		},

		mixin_summaryTypeName(appVue) {
			if (appVue.$store.state.neighborhoodId != null) {
				return "שכונה";
			} else {
				return "ישוב";
			}
		},

		// auth methods..

		async mixin_createUser(appVue, userName, email, password, token) {
			let path = "/users";
			var requestData = await this.mixin_generateTokenForPayload({ userName, email, password, path, token });
			const raw = JSON.stringify(requestData);
			let response = await fetch(appVue.$store.state.apiUrlBase + path, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: raw,
			});
			var res_token = await response.json();
			var res = await this.mixin_generatePayloadFromToken(res_token);
			// add statusCode to response
			res.statusCode = response.status;
			//save pwd in cookies
							  
			// Store password in cookie
			// compress password
			var obj = { pwd: password };
			var compressed = this.compressBase64Gzip(JSON.stringify(obj));
			this.mixin_setCookie("up", compressed);

			return res;
		},

		async mixin_sendToken(appVue, type, email) {
			let path = "/sendToken";
			// before sending token, ncrypt email
			var requestData = await this.mixin_generateTokenForPayload({ email, type, path });
			const raw = JSON.stringify(requestData);
			let response = await fetch(appVue.$store.state.apiUrlBase + path, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: raw,
			});
			var res_token = await response.json();
			var res = await this.mixin_generatePayloadFromToken(res_token);
			// add statusCode to response
			res.statusCode = response.status;
			return res;
		},

		async mixin_verifyAccount(appVue, email, token) {
			
			
			let path = "/verifyAccount";
			// before fetch, ncrypt the email
			var requestData = await this.mixin_generateTokenForPayload({ email, token, path });
			const raw = JSON.stringify(requestData);
			let response = await fetch(appVue.$store.state.apiUrlBase + path, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: raw,
			});
			var res_token = await response.json();
			var res = await this.mixin_generatePayloadFromToken(res_token);
			// add statusCode to response
			res.statusCode = response.status;
			return res;
			//return await response.json();
		},

		async mixin_resetPassword(appVue, token, email, newPassword) {
			let path = "/resetPassword";
			// before sending  ncrypt email + newPassword
			var requestData = await this.mixin_generateTokenForPayload({ email, token, newPassword, path });
			const raw = JSON.stringify(requestData);
			let response = await fetch(appVue.$store.state.apiUrlBase + path, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: raw,
			});
			var res_token = await response.json();
			var res = await this.mixin_generatePayloadFromToken(res_token);
			// add statusCode to response
			res.statusCode = response.status;
			return res;
		},

		async mixin_updateData(appVue, address, email, userID) {
			let path = "/pushData";
			//before fetch, crypt email + userID
			var requestData = await this.mixin_generateTokenForPayload({ address, path, email, userID });
			const raw = JSON.stringify(requestData);
			let response = await fetch(appVue.$store.state.apiUrlBase + path, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: raw,
			});
			var res_token = await response.json();
			var res = await this.mixin_generatePayloadFromToken(res_token);
			// add statusCode to response
			res.statusCode = response.status;
			return res;
		},

		async mixin_getData(appVue, email, userID) {
			let path = "/getData";
			// before fetch, ncrypt email + userID
			var requestData = await this.mixin_generateTokenForPayload({ email, userID, path });
			const raw = JSON.stringify(requestData);
			let response = await fetch(appVue.$store.state.apiUrlBase + path, {
				method: "POST",
				headers: { "Content-Type": "application/json" },

				body: raw,
			});
			var res_token = await response.json();
			var res = await this.mixin_generatePayloadFromToken(res_token);
			// add statusCode to response
			res.statusCode = response.status;
			return res;
		},

		async mixin_deleteUser(appVue, password, email) {
			let path = "/deleteUser";
			// before delete user, Encript password + email
			var requestData = await this.mixin_generateTokenForPayload({ email, password, path });
			const raw = JSON.stringify(requestData);
			let response = await fetch(appVue.$store.state.apiUrlBase + path, {
				method: "POST",
				headers: { "Content-Type": "application/json" },

				body: raw,
			});
			// decode response with mixin_generatePayloadFromToken
			var res_token = await response.json();
			var res = await this.mixin_generatePayloadFromToken(res_token);
			// add statusCode to response
			res.statusCode = response.status;
			return res;
		},

		async mixin_login(appVue, email, password) {
			let path = "/login";
			// get recaptchaToken
			if (appVue.$store.state.recaptchaToken == null){
				appVue.refreshRecaptcha();
			}
			var token = appVue.$store.state.recaptchaToken;
			var requestData = await this.mixin_generateTokenForPayload({ email, password, path, token });
			const raw = JSON.stringify(requestData);
			let response = await fetch(appVue.$store.state.apiUrlBase + path, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: raw,
			});
			let response_json =await response.json()
			var responseDataOrig = await this.mixin_generatePayloadFromToken(response_json);
			if ( responseDataOrig.hasOwnProperty("data")){
				if (responseDataOrig.data.hasOwnProperty("message")){
					responseDataOrig.statusCode = response_json.statusCode;
					return responseDataOrig
				}
				else{
					return 2222
				}
			}
			else {
				return 1111
			}	
		},

		mixin_share(platform) {
			
			if (platform == "facebook") {
				this.mixin_shareFacebook();
			}
			if (platform == "twitter") {
				this.mixin_shareTwitter();
			}
			if (platform == "whatsapp") {
				this.mixin_shareWhatsapp();
			}
			if (platform == "email") {
				this.mixin_shareEmail();
			}
			if (platform == "copy") {
				this.mixin_shareCopyLink();
			}
			if (platform == "telegram") {
				this.mixin_shareTelegram();
			}
		},

		mixin_shareFacebook() {
			const url = window.location.href;
			window.open(
				"https://www.facebook.com/sharer/sharer.php?u=" +
					encodeURIComponent(url),
				"_blank",
			);
		},

		mixin_shareTwitter() {
			const url = window.location.href;
			window.open(
				"https://twitter.com/intent/tweet?url=" + encodeURIComponent(url),
				"_blank"
			);
		},

		mixin_shareWhatsapp() {
			const url = window.location.href;
			window.open(
				"https://api.whatsapp.com/send?text=" + encodeURIComponent(url),
				"_blank",
			);
		},

		mixin_shareEmail() {
			const url = window.location.href;
			window.open(
				'mailto:?subject=nadlan.gov.il&body=' +encodeURIComponent(url),
				"_blank",
			);
		},

		mixin_shareCopyLink() {
			const url = window.location.href;
			navigator.clipboard.writeText(url);
		},

		mixin_shareTelegram() {
			const url = window.location.href;
			window.open(
				"https://t.me/share/url?url=" + encodeURIComponent(url),
				"_blank",
			);
		},
	}, // methods end
};
